import React from "react";
import LayoutMensajesVirgen from "../components/LayoutMensajesVirgen";

export default function MensajeVirgenEn() {
  return (
    <>
      <LayoutMensajesVirgen>
        <div className="col-12 text-center">
          {" "}
          MESSAGES GIVEN BY
          <h5>THE HOLY VIRGIN</h5>
          <h5>July 13, 1990 to April 1, 2003</h5>
          <h5>Salta - Argentina</h5> <br />
          <p>
            {" "}
            Distributed in: San Bernardo Monastery of Barefoot Carmelites of
            Salta. Caseros 73 - (4400) Salta Tel.: (0387) 431-0092 <br />
            "Salta: October 30th, 1997. Nothing prevents this publication. -
            Pbro. Dante Bernacki - Censor" <br />
            "Salta, October 31st 1997. - It can be printed for private use of
            the Faithful ones. - Mons. Moisés Julio Blanchoud - Archbishop".{" "}
            <br />
            "BLESSED AND ADORED IS JESUS HOLY EUCHARISTIC HEART" <br />
            "IT IS NECESSARY TO JOIN THE FLOCK BEFORE IT DARKENS" <br />
            "I HAVE NOT COME TO CRITICIZE NEITHER to DESTROY, BUT TO BUILD"
          </p>{" "}
          <br />
        </div>

        <div className="col-12 mt-5">
          <h6>July 13th, 1990</h6>
          <p>
            Our LADY OF THE TEARS, will tell you what she wants on the day 16,
            you should pray a lot for the sinners, for the heart-stricken ones,
            for those who suffer. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 31st, 1990 (being in prayer)</h6>
          <p>
            THE IMMACULATE CONCEPTION said: "I will make a great manifestation,
            so that everybody believes you."
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 11th, 1990</h6>
          <p>
            (After consecrating myself to our God, the Sacred Mother opened her
            arms and smiling with a lot of happiness said) <br />
            "Come my daughter, Praise be to God, the Angels will accompany you,
            God will open a road of light"
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Thursday 16th of August, 1990</h6>
          <p>
            María: You should pray for the peace of the world that is
            threatened, for the sinners, for those who suffer, for the
            heart-stricken ones. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Friday 17th of August, 1990</h6>
          <p>
            The LADY OF THE TEARS sends me to tell you that: <br />
            "Soon I will be with you, I should help those that need me, there
            are many sons that suffer for the distressing situation, to them I
            will give my Mercy, I need a place where my Blessed Son is also,
            next to his Church. There I will make big things. Do it soon; there
            are many people in need!" I will bless you Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 31st, 1990</h6>
          <p>
            My children: <br />
            The Rosary should not be used as an amulet, by means of the Holy
            Rosary daily prayer, we invoke the divine protection and we praise
            God. To our dear youths, I ask them to turn their eyes to Jesus, to
            save the world from the sin in which it is submerged. The daily and
            simple prayer pleases Our Lord more than anything. Pray, all of you,
            with great devotion and peace will be given to your spirits, and in
            this way you will prepare yourselves for God. I will bless you.{" "}
            <br /> Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 5th, 1990</h6>
          <p>
            My daughter: <br />
            You should pray every day the Holy Rosary, when you raise this
            prayer towards God, for the aching humanity, you make me very happy.{" "}
            <br />
            In this way you will make me known among the hearts that have
            forgotten me, and I will do big things for all my children, when you
            praise me, and praise God through me. I will bless you. <br /> Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 17th, 1990</h6>
          <p>
            My children: <br />
            Pray to the Father as He will listen to you, Jesus came, he prayed
            with you, learnt from The One who is all Love to the Father. <br />
            The Road, the Truth, the Life, and Him, is in the prayer, He will
            illuminate you so that you reach Him. Those who pray to the Father
            with devotion should not be afraid, because they will find Him
            through my Divine Son. Those who pray and don't sin will drink from
            his fountain. I will bless you. <br /> Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 20 1990</h6>
          <p>
            My children: <br />
            The world loves baal, he is materialism, and God wants to spread his
            Mercy on this earth and over the world, that’s why he asks you to
            look for "His Mercy". The youths love baal, they will fall one by
            one in the endless abyss of evil. Convert to God. <br />
            You should make these messages known, the MERCY is giving a great
            opportunity to the world, and soon, it can be very late. “María,
            Don't be afraid” I will bless you. <br /> Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 26th, 1990 (in prayer)</h6>
          <p>
            María: <br />
            I will reveal what I want at the right time, meanwhile God requests
            prayer and penance, to forgive the sins, without prayer there is not
            regret. <br />
            María: The world is on the edge of genocide. My soul is sad, the
            clamor of the voices goes up to Heaven, to reduce to silence these
            ones let the prayers go up. Pray, pray, Poor my children, poor
            children! <br />I will bless you Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October, 1990</h6>
          <p>
            María my daughter: <br />
            "Soon a very bloody war will start."
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 18th 1990</h6>
          <p>
            María my daughter: <br />
            I want you to pray for the Peace of the world and I want you to do
            penance and offer it to the Lord your God. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 23rd 1990</h6>
          <p>
            (While I prayed the rosary) <br />
            That day I had a vision of the Holy Mother, wearing white clothes
            from head to the feet. First she extended her arms, and from her
            hands came out extraordinary white and transparent lights. Her
            beautiful face was intensely sad, and her face was looking down.
            Then she joined her hands in an attitude of prayer and then she
            looked up, without uttering a single word.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8th, 1990</h6>
          <p>
            (Being in prayer the Holy Mother said) <br />
            "I am MARY, MOTHER OF ALL THE PAINS and OUR LADY OF THE TEARS" She
            spoke to me about all the offenses against our Lord that are
            permanent, and she showed me the Divine Heart of JESUS crowned with
            thorns.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 9th, 1991</h6>
          <p>
            Daughter: <br />
            The prayer is a means of union, between God and men. One morning
            when I woke up and started praying, I had a vision of Jesus on the
            cross, and He said: "I am thirsty, give me something to drink"
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 11th, 1992 (in prayer)</h6>
          <p>
            Daughter: <br />
            Listen to your Mother's message as she cries for so many bewildered
            children. I want you to pray without stopping. How many sins offend
            our Lord! You should think that He died and He gave himself for all
            of you, in Cross death, you do not deserve God. <br />
            Pray all of you so that the world converts itself. Pray, do penance,
            look at Jesus Christ’s Glory, read the Gospel, practice God’s Word,
            with sincere heart. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 4th, 1994</h6>
          <p>
            Early in the morning while I was praying, I saw in front of me, an
            ANGEL, when I saw him I felt a great joy, inside and outside me, a
            deep groan escaped from my mouth before the presence of this Angel
            of extraordinary beauty, it was not its beauty alone what really
            impressed me, but his presence from where emanated a great joy and
            was transmitted to me, making me feel a great interior happiness, it
            was a very difficult experience so as to explain it with words.{" "}
            <br /> He was dressed in white and he had a cord tied around his
            waist, his aspect was hefty and radiant. When I saw him I thought he
            looked like a 17 year-old boy, his hair was blond and it went down
            just below his ears. He took a long stick in one of his hands that
            surpassed his head, and he touched the floor with it. He stood in
            front of me and for a while (I don't know how long) he said nothing;
            he just looked at me firmly and with a lot of insistence. I asked
            him Who are you? <br />
            A: I am an Angel; I belong to the royal guard of the celestial
            legions, under Saint Michael Archangel's orders, in the fight
            against Satan. Then he told me: <br />
            Listen sincerely and pay attention. Do they believe God will allow
            people behaving abominably in His House? God is a Father that
            corrects. His LOVE reaches good and bad people, His patience is
            Endless, the anger of God has not still loosened against the
            merciless, because he is the only Creator of all the things that
            exists, He, is the power over the power, his Mercy is endless, God’s
            Love can save you. <br />
            Happy of you as you work well, blessed are your sufferings! (He
            remained quiet as if he was waiting for my words) I asked him What
            shall I do? <br />
            A: I am a servant, He is the one that is sending me, be a good
            servant, do what I did. Praised and glorified is the Lord forever,
            Blessed and Praised.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 13th, 1995</h6>
          <p>
            (While I prayed the Glorious mysteries of the Holy Rosary) <br />
            That day I had a vision of the Holy Virgin, OUR LADY OF SHOENSTTAT
            Mother, Queen and Victorious. The Virgin and baby Jesus turned to
            life inside the picture, She, the Holy Virgin, was smiling and the
            Baby was also in the middle of a great and radiant light, the Divine
            Baby Jesus in her arms touched lovingly with his little hand the
            Holy Virgin's face, then the Baby bent over her and kissed Mary’s
            Heart and then his little hand entered into the Virgin's chest, he
            took in his hands the Virgin's Heart lovingly, and then he held it
            with his little hand like offering it, and while he made this, with
            his other little hand He blessed through the Immaculate Virgin’s
            Heart the whole city and the world. <br />
            Their faces were always smiling and cheerful, inspiring great trust,
            then the vision left. After this my soul was full of happiness, with
            great joy and interior peace.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 20th, 1995</h6>
          <p>
            María my daughter: <br />
            You should always trust my Son’s Sacred Eucharistic Heart; I want
            you to address him constantly in all your prayers. Today I ask you,
            daughter of my Heart to pray a lot for those who are ill and to try
            to make each soul and each heart to be attracted especially with
            force toward Christ's Heart as he suffers for each one of you,
            mainly for the sick people, let the Passion absorb you, step by step
            and ask for the sinners, you should concentrate my daughter in the
            empty souls and try to fill them with your prayer so that Jesus can
            penetrate them. That’s all my daughter, Praised is the Name of my
            son Jesus. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 22nd, 1995</h6>
          <p>
            Dear children: <br />
            Today I want to protect you from the evil, satan works, he will try
            to dominate you even through people, even through those that are in
            the Church, satan and his wicked spirits, won't make them known
            easily but rather they will be hidden with lamb skin, and subtly
            they will sow the evil, he will especially attack the Church and all
            the places where the Word of my Divine Son Jesus is taught, he will
            settle in those places to try to lose them, and in his mortal trap
            many can fall, especially those who don't watch over the entrance of
            their hearts, that’s why I ask you to permanently fast, to be in
            prayer and penance, mortify the body to make it stronger inwardly, I
            speak to everybody, remain vigilant because satan is watching over
            you and he always waits for the opportunity to get you lost. <br />
            I tell you this, not to frighten you, but to prevent you, get ready
            as well as the earth gets ready for the sowing, day by day with
            perseverance, praise God in each thing you do, bless the Name of
            God.. <br />
            God bless you my children. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> April 1st 1995</h6>
          <p>
            That day while I prayed the Stations of the Cross (in my bedroom, I
            had the following vision) I saw before the Tabernacle of the parish,
            Jesus' wounded Heart, the Heart had a deep wound, and when it beat,
            from the wound, thick drops of Blood spilled out. At the same time
            our Lord made me known the suffering that there was in that spasm,
            when the drops of Blood were released, it was physical and moral
            pain, that pain was something so inexpressible that I could not
            support it and I began to faint, and I felt that my heart would not
            resist, but our Lord took it off, if he hadn’t done so I would have
            died. <br />
            Our Lord showed me how much LOVE there is in his Adored Heart, How
            much LOVE he keeps in the Tabernacle, ALIVE and PRESENT! Immense,
            Endless LOVE for us, suffering through the centuries His Saving
            Passion! <br />
            The Holy Trinity is present in Jesus' Holy Eucharistic Heart. After
            finishing this vision these words appeared "I am THE HOLY
            EUCARISTICH HEART OF JESUS, ADORE ME PERPETUALLY IN REPAIR"; and he
            inspired me the following prayer to be prayed before the tabernacle.{" "}
            <br />
            Jesus Holy Eucharistic Heart, I Trust in Your Mercy vastly. I ask
            you humbly to give me the faith that I need to abandon myself to
            your Endless Mercy because my human resources have already been
            drained and now it is only necessary to return with trust to your
            Endless Compassion, because I know that YOU won't ignore my request.
            Here I am Lord at your feet requesting with fervor you fix all my
            things and problems, according to your Love and divine approval that
            I know will be the best thing for me, grant me what I am asking for,
            if it is right for my soul. <br />
            Pick up My problem, my Lord. <br />
            Take my heart! I trust you, Jesus Holy Eucharistic Heart. I trust
            you, Jesus Holy Eucharistic Heart. <br />
            I trust you, Jesus Holy Eucharistic Heart. <br />
            I trust you, Jesus Holy Eucharistic Heart. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 21st, 1995</h6>
          <p>
            (At Our Lady of. Shoensttat´s Sanctuary). That day while I adored
            Holy Jesus, the Holy Virgin said, Dear children: <br />
            Today I have come to you, to ask you to pray, and pray for all the
            people that are in need, for those that are pursued, for those that
            suffer hunger and abandonment, for the heart-stricken and the sick,
            for the children victims of the world, because they walk in the
            middle of the evil, contaminated by the sin; if you don't pray my
            dear children, humanity walks toward its destruction, you are the
            chosen, so that by means of the prayer you will be able to stop the
            punishment that is waiting for you. Pray to the Father who is in
            Heaven, do it on behalf of his Son Jesus Christ. <br />
            Prayer, prayer, prayer. Listen to this Mother of Heaven who knows
            how to save her children, be humble my children, so that your prayer
            reaches Heaven. <br />
            Blessed and praised is God. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 10th, 1995</h6>
          <p>
            Jesus message: <br />
            When the day of the trial arrives, all of you will resuscitate, I
            assure it to you, from the first man Adam, and the first woman Eva,
            and with them the last of the last ones and on that day the whole
            creation will be expectant, sky and earth will see each other.{" "}
            <br />
            The Father, The Son and The Sacred Spirit, the Glory of Glories,
            blessed will be the saints and damned the damned ones. <br />I have
            sent you Mary my Mother, he who listens to her, listens to me.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 11th, 1995</h6>
          <p>
            When asking to the Virgin, about “women” <br />
            You are a woman!, the biggest yearning in my Heart, is that when you
            think about me, you should never separate me from my Son Jesus, I
            have been from my mother's stomach, conceived for Him, born for Him,
            my life is for Him, with Him and in Him, and now that I am with Him
            all my Heaven is Him. <br />
            Women of the world, the third millennium approaches, the woman is
            the one who will be the owner of this time. Be strong; do not allow
            the essence, which came with you when God gave you life, to get
            lost.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 13th, 1995</h6>
          <p>
            Jesus message: The world never wondered, how many tears I have
            spilled for you during my Passion and how many bitter tears my Holy
            Mother has spilled, to help to the Redemption, I ask you to honor
            each tear that I spilled for you during those bitter hours, I
            promise the person who honors them praying every day of his life
            five Lord’s Prayer five Hail Maries and five Glories: <br />
            1- To attend him with my Holy Mother, in the final battle of his
            life. <br />
            2- The total conversion of his soul. <br />
            3- A true contrition of his sins. <br />
            4- On the day of the trial, to forgive him so that he enters with Me
            into the Glory. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 9th, 1995</h6>
          <p>
            Dear children: <br />
            Let Gods Love and Peace be with you. <br />
            Today I have come to ask you to pray the Holy Rosary every day, in
            order to begin your conversion, the second step will be the
            amendment of your souls, by means of the Holy Sacrament of
            Confession and the Holy Mass, and attend mass every day without
            being absent on Sundays. Be perseverant in the Holy Rosary's daily
            prayer, this simple way of prayer, will transform your lives, be
            perseverant in the execution of these three orders and you will be
            transformed soon; perhaps at the beginning it will be a little hard,
            but if you do so I promise you great Graces. You do what I am asking
            for soon, the conversion is urgent, I want to have all my children;
            The doors of Heaven are open to all of you! Open your hearts! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15th, 1995</h6>
          <p>
            María daughter of my Heart: <br />
            I want you to look at Heaven, where I live in Glorious body and
            soul, with the Angels and the Saints; look at me my daughter (she
            looked at me and opened her hands and from them came out lightings
            of pure lights ) and she said: <br />
            Just look at my happiness, take part of it my daughter; this is the
            gift of your Mother of Heaven, the one she wants to share with you.{" "}
            <br />
            My soul praises the greatness of God and my spirit is happy in the
            Glory of God, eternal are God and Savior’s Mercies, happy are those
            who wait in God, because they will be satiated in the spring of
            alive water, and they will be nor hungry neither thirsty because
            they will see God. Be humble my daughter, preach humility, you have
            sustained a great battle, don't be afraid I will be with you until
            the end; I am Holy Communion within your heart. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 5th, 1995</h6>
          <p>
            My children: <br />
            Don't be rebel in front of your Father who is in Heaven, on the
            contrary always offer him, thanks and commendations, to suffer
            everything with great resignation and patience, since the virtue of
            patience is the one that will Sanctify you, offer everything to Our
            Lord, don't look for the vain things of this world, but on the
            contrary pray, pray the Holy Rosary, as much as you can, the more
            you pray the more Graces you will get. <br />
            If you don’t pray and you don’t confess, at least once a month, you
            don't grow spiritually, and you give the opponent the opportunity to
            find you with little strength. <br />
            Convert yourselves my children! Make this known. <br />
            Amen. Hallelujah. Amen. <br />
            God bless you.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 6th, 1995</h6>
          <p>Why are my messages kept? Ezekiel chapter 15 chapter 32</p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 25th, 1995</h6>
          <p>
            Dear children: <br />
            I speak to all my children those who have gathered today in so many
            places to worship me, I am so Happy!! Because I see each one of you,
            I listen to each one of you in particular, I see your hands asking
            me for Graces, I promise you to take all your requests to Heaven and
            to put them at the feet of the Holy Trinity, I am your lawyer,
            powerful intercessor before the Throne of God. I want your Prayer
            and your Reconciliation. He who does what I order, will receive true
            peace of JESUS EUCHARISTIC LOVING HEART and the healing of his soul.{" "}
            <br />
            I want to reiterate my order during this special day, CONSECRATE
            YOURSELVES TO THE IMMACULATE HEART OF MARY because my Immaculate
            Heart will succeed and those who are consecrated will succeed with
            It; and consecrate yourselves to my Heart with the Holy Rosary's
            daily prayer! Oh my sons, if you were able to know all the things
            you will receive when you pray with devotion the Holy Rosary. <br />
            Be happy in the hope of those who return to God! <br />
            Blessed and praised is the HOLY EUCHARISTIC HEART OF JESUS <br />
            Blessed and praised is JESUS, EUCHARITIC. <br />
            Blessed and praised is THE HOLY TRINITY present in the HOLY
            SACRAMENT. <br />
            Amen Hallelujah, Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 13th, 1995</h6>
          <p>
            (Praying in my bedroom) Dear daughter: <br />
            With happiness I receive all the commendations, prayers and tears of
            love for my Divine Son Jesus, especially today. The world should be
            consecrated to my Immaculate Heart. The time has already shortened;
            the signs will warn you that all the prophecies that I have given
            through time will be completed, it is absolutely necessary to move
            to an urgent conversion toward God. My heart of Mother suffers for
            those who do not listen to my urgent calls for conversion. <br />
            God allows me to warn you, about the terrible things that will
            happen to mankind because He is Merciful, in the darkness that is
            coming; the light will no longer shine. The most terrible
            tribulations are waiting for you, the physical tests that you will
            be obliged to pass will be completely unbearable but the spiritual
            tests will also be more tortuous than whatever suffering man has
            suffered since his creation. <br />
            The opponent's hate will loosen then with all its strength and he
            will drive the nations of earth mad. The fire that will fall from
            Heaven will paralyze all of you with terror and the roar will be so
            great that it will move the whole Universe, after this only 3/4
            parts of mankind will survive. <br />
            The sign that I have announced you will be seen in favor of the ones
            who have been chosen by God, He will give you time to be prepared
            waiting for that great moment, the children who have listened to me
            will be prepared, and on that day you will fall on bending knees as
            penitents and you will pray in this way: Holy Trinity let your Holy
            will be completed, Be Merciful with us, Be Merciful, Have Mercy,
            Have Mercy. Oh Merciful God, Mercy! For the Blood of the Lamb be
            Merciful, For the Passion of the Lamb be Merciful For the Wounds of
            the Lamb be Merciful. <br />
            For Your Son, God’s Lamb, listen to us Father be Merciful in the
            Blessed name of your Son Jesus. Amen. <br />
            I ask you for an URGENT conversion to Mary’s Immaculate Heart, to
            mitigate these horrors that will happen due to your sins, my little
            daughter, the world is sailing in a dirty pond, submerged in all
            kinds of sludge, already impossible to compare, since something like
            this has never been seen since your creation. <br />
            The nauseous and dense scent ascends toward God and there are just a
            few souls praying, the punishment is already at the doors. <br />
            My requests will stop the Hand of God, I ask for more prayers,
            especially from those who have CONSECRATED themselves, pray without
            stopping and Love God, love him who is SAINT, SAINT, SAINT. Let the
            Sacred Fear toward God returns to your hearts! <br />
            Those that believe my words and convert their souls will be saved.
            My daughter make this message known, today like yesterday you have
            to make an URGENT CALL TO THE LOVE OF GOD. I bless you, daughter of
            my Heart. <br />
            Amen, Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 29th 1995</h6>
          <p>
            (being in prayer) <br />
            Dear children: You think that Heaven is a distant and unreachable
            place. There are some who do not even believe in it, today I want to
            say dear children that Heaven is next to you. I invite you to go
            into a Temple and to go next to the Tabernacle and to look at Him,
            there you will be contemplating Heaven, here on earth, because JESUS
            is Heaven, and where He is, Heaven is. He is GOD! Put yourselves in
            prayer, knowing that He is present in all the Tabernacles of the
            world. Let Him guide you; do what He tells you to do. <br />
            I love you all. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> October 31st 1995</h6>
          <p>
            After taking communion, I had a vision, when I closed my eyes to
            speak with Jesus, the Face of the Sacred Shroud appeared in front of
            me but not as It can be seen, in a piece of paper or in a picture,
            but real, all his Face was illuminated and his sufferings could be
            seen, that was impressive for my soul. He looked at my heart with
            his closed Eyes and I looked at him with my heart.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 5th 1995</h6>
          <p>
            My children: <br />
            I bring you a word from Heaven, HOPE, HOPE, HOPE! <br />
            How can my children understand the GODS LOVE if they live in
            despair? Think <br />
            Hope: it is to wait in God and just in Him; to wait everything from
            him, putting all your efforts, but looking at the hope that is in
            Heaven. <br />
            In the LOVE that GOD has for you it is the hope, because GOD is
            LOVE, and GOD´S LOVE contains everything. Praise be to Jesus!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 6th 1995</h6>
          <p>
            Dear children: <br />
            I have come to visit you to fill you with blessings from Heaven,
            although many of you find it hard to believe; because you don't have
            faith, sons, if you open your hearts, this Mother will be able to
            take them to conversion, I bring you a lot of Love and Hope. <br />
            I want you to listen to my messages, I, Jesus' Mother is very happy
            among you because you have already begun to answer me and you will
            see that God, will be in your hearts, especially the hearts of the
            youngest, as I have put my hopes in them. <br />
            I invite you to a radical change in your lives; follow my messages
            carefully because through them, I will teach you how to get closer
            to God. Thank you for opening your hearts! This is time of Mercy.{" "}
            <br />
            There is a light that shines among you. Pray, Pray. <br />
            Bless and praise be to The Eucharistic Heart of Holy Jesus.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 18th 1995</h6>
          <p>
            Be conscious dear children that God is alive, next to you. <br />
            He is the creator of all the things that your eyes can see and even
            beyond that. <br />
            I want you to start thinking seriously about this, read the Holy
            Bible, ask the Holy Spirit for light to have a better understanding.{" "}
            <br />
            Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 18th 1995</h6>
          <p>
            Last night I had a vision: I saw a garden full with rosebuds of
            white roses gathered. When I asked about the meaning of what I was
            seeing, it came to me. White roses symbolize purity.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 22nd 1995</h6>
          <p>
            Work, my children Work, Work with happiness for the Glory of God’s
            Kingdom! Amen (In a private message) Prayer to ask for Wisdom" My
            God and my Merciful Lord! Give me Holy Wisdom that comes from your
            endless kindness, Open the eyes of my faith to the eternal light, So
            that they can see you, because your wisdom Lord, is more radiant
            than the sun. Lord, guide my thoughts with your Wisdom, So that, it
            can be the source of my knowledge and work Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 25th 1995</h6>
          <p>
            Today I have a vision of the Holy Mother, in attitude of deep
            prayer, her face remains down. She has her hands together at the
            height of her face, for some minutes she remains in silence and then
            she tells me. <br />
            Dear children: <br />
            I am calling you all to conversion and you should pray a lot if you
            want this to happen. Ask the Holy Spirit for his work in your hearts
            by means of daily prayer, so that you can live as true Christians.
            You cannot imagine how important prayer is. She can open an immense
            channel of Graces, if you are perseverant. Start praying today, so
            that God’s love can fill all the spaces of your hearts. <br />
            Only the Holy Spirit can convert you and take you to Sanctity.{" "}
            <br />
            He is the one in charge of conveying all the Graces that come from
            the only SAINT, SACRED, the SACRED TRINITY. Blessed are my children.{" "}
            <br />
            Amen Hallelujah, Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 27th, 1995</h6>
          <p>
            I will try to explain with words what God told without words. <br />
            After taking communion with the Body and Blood of Jesus, the immense
            LOVE OF GOD invaded me. This immense LOVE arrived to my soul in deep
            silence, He remained in me and without words he told my heart that
            this infinite LOVE of God it is in all of those who receive It by
            means of the Holy Communion, in his infinite Mercy he communicates
            with every souls, even with those that don't receive him, to call
            them and to give them life, with his immense and present LOVE in the
            HOLY SACRAMENT. And THE LOVE tells me to pray in this way: <br />
            Oh infinite love that never stops calling! <br />
            Oh infinite Passion that never stops suffering! <br />
            You call <br />
            You suffer <br />
            And you love the souls <br />
            Because souls of your Soul are <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 28th 1995</h6>
          <p>
            Jesus says: <br />
            Nothing will be denied to the soul that asks for something trusting
            JESÚS'S HOLY EUCHARISTIC HEART! I call you and I wait for you.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 28th, 1995</h6>
          <p>
            Dear children: <br />
            Make yours, my Song ". Praise God with it. Because whenever you do
            this, the Angels and Saints in Heaven will do it with you. <br />
            Amen. Hallelujah. Amen. Hallelujah. <br />
            "My soul sings the greatness of God, <br />
            And my spirit shivers of joy in God my Savior, <br />
            Because He looked with kindness at his servant’s littleness . <br />
            From now on all the generations will call me happy, <br />
            Because the Almighty has made big things in me: <br />
            His Name is Sacred! <br />
            His Mercy extends from generation to generation Over those who are
            afraid of him. <br />
            He displayed the force of his arm, He dispersed those who are
            selfish. <br />
            He demolished the powerful ones from their thrones And He rose the
            humble ones. <br />
            He filled the hungry ones with goods And He let the rich ones go
            with empty hands. <br />
            He aided Israel, his servant, Remembering his Mercy, As He had
            promised it to our parents, In favor of Abraham and in favor of his
            descendants forever."
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 30th, 1995</h6>
          <p>
            After receiving the Holy Communion Jesus said: "I am the endless
            kindness suffering for the souls. Bring souls to my Heart"
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 1st, 1995 (first Friday)</h6>
          After receiving the Holy Communion, Jesus said: I am “THE DIVINE
          EUCHARISTIC HEART OF JESUS”. Come close to my Heart, don't be afraid,
          I will favour you. I am the LOVE, without limits.
        </div>

        <div className="col-12 mt-5">
          <h6>December 1st, 1995</h6>
          <p>
            (Being in prayer the Holy Mother said) Dear children: I am speaking
            to you during this time of Mercy. Don't miss it without coming
            closer to God. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 4th, 1995</h6>
          <p>
            Dear children: <br />
            The Holy Spirit inhabits you, because you are children of God. Don't
            live according to your bodies, but according to the Holy Spirit,
            think, and live according to the Spirit, Praying and requesting his
            strength to conserve the Grace. <br />
            Be in good mood my children, remain in prayer. I will always be with
            you. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8th, 1995</h6>
          <p>
            On this very special day, I came my children to give you, my great
            Love for you. All my being has been preserved pure for the Holy
            Trinity. In my pure breast embodied the Immaculate and Sacred Verb,
            the Infinite Light that enlightens eternity. In the wonderful plan
            of God’s love to save the whole humanity. <br />
            Meditate about this my children; put the light in your hearts, so
            that it begins to shine as torches. Bless, Praise and Glorify God.{" "}
            <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 12th, 1995</h6>
          <p>
            Be obedient my daughter, complete the mission, you are messenger, an
            instrument of faith, you should obey God’s orders, so that the towns
            and the cities of the world can go further in the knowledge of God’s
            love. <br />
            The towns will praise him. Don’t be afraid! In the simplicity of
            your heart our Lord is revealed. Praise be to JESUS'S HOLY
            EUCHARISTIC HEART. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 12th, 1995</h6>
          <p>
            Dear children: <br />
            I have come to take you through the road of true life, "Jesus ".{" "}
            <br />
            This Mother will make your road easier. Open your hearts!, listen to
            my messages, I want you to begin walking together, through the road
            that drives to Heaven, Pray the Holy Rosary! Praise God’s Glory with
            it. <br />
            Glory to God.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 13th, 1995</h6>
          <p>
            (after receiving the Holy Communion) <br />
            Jesus says: <br />
            "I am the eternal Lover of the souls. Look at the Glory of my Divine
            Heart, in flames with Love for you, exposed to all sights.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 17th, 1995</h6>
          <p>
            Dear children: <br />
            I bring you the light that you already have in your interior, but
            you cannot see it because of your sins, I will help you so that you
            can see Christ's light in your hearts. <br />
            The work of Lord’s MERCY for this town, will cross frontiers and it
            will be spread over the whole world. <br />
            Sons convert yourselves! All of you should listen to my teachings,
            Peace arrives, Love arrives, be happy due to this unique and urgent
            call to find God. <br />
            Praise be to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 19th, 1995</h6>
          <p>
            Dear children: <br />
            Adore my Baby Jesus, as we adore him with Joseph, start adoring him
            with your heart, let Him begin to be born in your homes during this
            Christmas. <br />
            I am speaking to you about a very special Grace for you my dear
            children; don't allow it to pass by without conversion. I love you
            all. <br />
            Hallelujah, Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 27th, 1995</h6>
          <p>
            Loved children return to Jesus, start looking at it from the moment
            when he is born. Look at the poverty, where the Savior is born.{" "}
            <br />
            Start to live with the Divine Baby Jesus, dying to yourselves and
            being born to Celestial things. Hallelujah. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 27th, 1995</h6>
          <p>
            Dear children: I exhort you to live as true Christians, GOD´S
            CHILDREN, and in this way your work will be good and true; worthy of
            God’s Kingdom. Hallelujah. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 28th, 1995</h6>
          <p>
            Sons pray day by day, to get to know WHAT IS GOOD and to reject WHAT
            IS WRONG. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 1st, 1996</h6>
          <p>
            Dear children: <br />
            I want that you start this New Year next to the Mother of God.{" "}
            <br />
            Put your desires in my Heart so that I, as Mother of Jesus and your
            Mother, can help the love of the Father, the Son and the Holy Spirit
            to work inside you. <br />
            The infinite Love of God, wants to help you to mature in FAITH, HOPE
            AND CHARITY through me. So that the perfect work of God’s Love who
            is Savior is carried out in your lives. <br />
            Be happy my children, praise the Holy Trinity. <br />
            Convert yourselves! <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 2nd, 1996</h6>
          <p>
            Dear sons: <br />
            Pray the Holy Rosary in family, think that when you do so, I am with
            you, start now, with this New Year. I want to be in all the homes,
            to help you through out the difficulties. I want you to know me.{" "}
            <br />
            Lord is giving you this Grace as a present, don’t be indifferent. I
            Love you!. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 5th, 1996</h6>
          <p>
            Pray one for the other my children; remember that God wants the best
            for you. Be good with your siblings that suffer, during the prayers
            once you have asked for your necessities ask for the others. You
            don't live alone, due to the Endless Love of God you have siblings
            and they should share with you the Love and the Peace God. <br />
            Bless God and bless your siblings, and in this way you will please
            the eyes of God, you will receive great spiritual benefits and God’s
            Peace will come to your hearts. <br />
            Live this, as I am teaching it to you! <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 7th, 1996</h6>
          <p>
            Dear children: <br />
            Remain together in prayer toward the Almighty, feel hungry of his
            Love and you will be filled with his infinite Love, which can do
            anything. Don't miss this moment of Grace. The infinite Mercy
            exhorts you to an urgent conversion. <br />
            Recognize yourselves as God’s children, listen to His Word and allow
            it to penetrate in your hearts, implore this Grace to His Divine
            Love. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 8th, 1996</h6>
          <p>
            María little daughter of my Heart: <br />
            Praying with the Holy Rosary means being near my Heart, every time
            you pray it my eyes remain looking at you, my Heart listens to you,
            and I become more insistent in my request. <br />
            I am a bridge of union between you and the Holy Trinity. I bless
            you. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 11th, 1996</h6>
          <p>
            Pray! My Children, Pray! With intense love, darkness is already
            hanging over Humanity. Take the weapon! It is the Holy Rosary. My
            children do what I am ordering you, so that the Light conquers the
            darkness. <br />
            Amen. Amen. Amen. <br />
            The Holy Virgin is in white and she has her face bathed with Tears
            and before speaking she allowed me to look at her face.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 11th, 1996</h6>
          <p>
            Jesus says: <br />
            Which right do you have to admonish your Priests? Didn't I teach you
            to love everybody? <br />
            If you are my town and you are rotten, each one of you carry a load
            of sin. First you should pay your debts so that I forgive you, be
            real managers to start a work of rebuilding in its fair measure, be
            afraid of God. Guard the doors of my Kingdom with my infinite Love.{" "}
            <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 17th, 1996</h6>
          <p>
            I saw a dry field, full with thorns and overgrowths, with a
            beautiful garden in the middle of it, full with rosebushes with
            enormous pink roses, contrasting with the field. I also saw gigantic
            trees, full with enormous pink roses. <br />
            The Mother tells me: <br />
            Many difficulties are waiting for you now. The beautiful garden is
            my Heart, in the middle of the world, the roses represent those that
            pray the Holy Rosary, and they grow as gigantic trees, going up to
            Heaven with many spiritual fruits. <br />
            He who gives me his heart and prays the Rosary should not be afraid
            of anything of this world, since this Holy prayer raises them above
            all the difficulties and it protects them especially from all
            danger, bringing them next to God fast, it makes them grow inwardly,
            preventing them from being contaminated with wickedness. <br />
            This protection is what God gives to those who pray the Holy Rosary.{" "}
            <br />
            Teach this. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 18th, 1996</h6>
          <p>
            Jesus says: <br />
            "Come to Me, all of you who are overwhelmed, I will alleviate your
            load". Come to find shelter in My Holy Eucharistic Heart. <br />
            The Mother! Holy Mary says: <br />
            When My Divine Son speaks, Heaven and Earth are prostrated in
            adoration. Each Word of God has the weight of all the eternity. Obey
            him and praise him by means of the prayer. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 19th, 1996</h6>
          <p>
            Sacred Mary says: <br />
            I tell the youths: open your hearts to this Mother of Heaven, so
            that she can teach you which is the only true way toward happiness.
            If you allow me to enter in your lives, I will guide you through the
            way to rightness, I will show you the true morality, the one you
            should have in your lives; I will teach you to be pure of body and
            soul, in order to know the true happiness that is born from Jesus'
            Heart, my Divine Son. <br />
            Put Jesus in the center of your lives. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 25th, 1996</h6>
          <p>
            Thank you for listening to me! <br />
            I will ask you to live in prayer praising the Celestial Father
            continually. You will be able to make his Will only if you have the
            force and the light that the Holy Spirit will give you through
            prayer. To start, fast! at least once a month. Fasting means being
            deprived of something because you love Jesus. You don't know the
            power of fasting and prayer. <br />
            Start fasting and praying and the power of darkness will be
            defeated!. <br />I love you. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 1st 1996</h6>
          <p>
            Dear children: <br />
            Pray for the Peace! For the peace and the love that should reign in
            each home and in each heart. Especially the peace of hearts. <br />
            Convert yourselves entirely to the Lord!, you should always try to
            do what he wants, don’t allow anything to prevent you from doing so,
            to do so, fight in the middle of the difficulties. <br />
            Put yourselves in prayer, in order to discern which God’s will is in
            your lives and to be able to carry it out. <br />
            Find peace in your hearts through prayer. <br />I love you to all.
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 2nd, 1996</h6>
          <p>
            You are dear and blessed children by God, pay attention to my
            messages, because in them God is calling to a true conversion. Amen.
            Amen. Read Psalm 14.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 3rd, 1996</h6>
          <p>
            Dear children: <br />
            I am your Mother! I invite you to put all your hope in God. <br />
            Constantly praise to God, in every act of your lives, grow inwardly
            through prayer. You cannot live with happiness if you don't have God
            in your hearts. To live a true Christian life, start looking at
            Jesus; try to understand the divine things, until you are able to
            fill your thoughts and your hearts with God’s Love completely.{" "}
            <br />
            Put interest to know which one the Father's Will is, praying with
            insistence and fasting. <br />
            Look at the brother that suffers. Spread your hands to those who
            need most, putting in your hearts the burning desire to pray for
            them. And by this means you will achieve incredible things from
            God’s Love. Be strong in your prayer and peace will increase in your
            souls. <br />
            You are blessed! Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 7th, 1996</h6>
          <p>
            Dear children: <br />
            Be real followers of Christ, according to the teachings He left you.{" "}
            <br />
            Open the Sacred Gospel! And begin to give God Glory. Learn his
            Divine Word and what He sends. The Word of God is not to live
            according to the world, but to get ready to live in Heaven. <br />
            Be happy my children! God is Merciful with those who are humble of
            heart; don't allow this special moment to go by. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 8th, 1996</h6>
          <p>
            Dear children: <br />
            Be strong during this moment; glorify God with your lives. Praised
            God during each moment of your life, fulfilling your obligations and
            giving each one the best you have. <br />
            Work always with the Holy Spirit of God, in this way you will be
            conquerors and your Father of Heaven will call you using your name,
            and he will recognize you as his children. <br />
            Pry my dear children, pray. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>(The Roses) February 11th, 1996</h6>
          <p>
            Pray my children! And believe in the Gospel. <br />
            Convert yourselves to God! And all the towns of the world will find
            peace. <br />
            Pray intensely, so that many souls return to Lord. Pray for the
            people who are ill, because many of them suffer without even knowing
            God’s Love, pray for them my children, pray. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 12th, 1996</h6>
          <p>
            Dear children: <br />
            Return your eyes to the Holy Sacrament, source of fertile life and
            eternal health. Learn to know your present God in all the
            tabernacles of the world. Pray intensely in front of Jesus
            Eucharistic. Put yourselves in His Hands sincerely so that Jesus who
            is Love, can transform you in this way. Remain humble and respectful
            in his presence. He is God! Teach this. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 13th, 1996</h6>
          <p>
            Come my children to my Immaculate Heart. This maternal Heart will be
            your strength. I will always preserve you, I offer you my Immaculate
            Heart full of Love for you" <br />
            Amen. Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 14th, 1996</h6>
          <p>
            My children: <br />
            I am sad because many of you suffer the consequences of this time;
            most of you try to solve the problems far away from God. For many of
            you, God doesn’t exist. <br />
            This is a time of Mercy. I invite you to live deeply in Love. Open
            your hearts to the Love of Jesus Christ and He will listen to you
            and you will move away from the darkness, your souls will open up to
            receive the Spirit of God, and the Divine Wisdom will be your guide.
            If you want to be free you should reconcile soon with God. <br />I
            love you, Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 16th, 1996</h6>
          <p>
            My loved children: <br />
            I want you to understand how big it is the Love of the Father of
            Heaven. Some of you live in complete darkness, but due to the Divine
            Mercy, you will receive God’s Love, as well as those who live with
            the Holy Spirit’s light. <br />
            My children I have come to bring you HOPE, and in this way those who
            are walking in darkness are going to be illuminated. <br />
            Don't live the misfortunes of this world, as if it was your last
            aim; watch everything with the light of faith in the Word that Jesus
            left you, He suffered everything, that is why you should remain firm
            in the road that takes you to Heaven. <br />
            Convert yourselves! To illuminate the world, reflecting with your
            lives my Son’s Divine Heart, Jesus. <br />
            Glory to God! Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 17th, 1996</h6>
          <p>
            Pray to God with the Holy Rosary, invoke God’s protection, by means
            of this prayer that is powerful and soon you will feel in your lives
            the force and the light of the Holy Spirit. The Holy Rosary is the
            most beautiful ornament of your soul; go for it at every moment.{" "}
            <br />
            I am in the Holy Rosary, as God’s Daughter, God’s Mother, God’s Wife
            and loving Mother of all of you. I love you my children! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 19th, 1996</h6>
          <p>
            In the prayer my sons you remain joined to the Father, to the Son
            and to the Holy Spirit. <br />
            When you leave the door of your hearts open with your prayer, to
            God’s infinite Love, you receive extraordinary Graces. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 23rd, 1996</h6>
          <p>
            Dear children: <br />
            Come closer to the infinite “Love of Jesus' Eucharistic Heart."{" "}
            <br />
            These are preparation times. Don't waste time in vain things of this
            world, leave behind you the spirit of evil. <br />
            Listen to my messages with meditating spirit, I am speaking to you
            dear children so that you grow spiritually, be kind and merciful;
            trust the Infinite Kindness of God., in order to be perseverant
            doing his work with his Graces as good Christians. <br />
            "Return your eyes to Jesus Christ." <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> March 2nd 1996</h6>
          <p>The Mother says: "I am the Glory of this town"</p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 3rd, 1996</h6>
          <p>
            My children: Let the Father's Love, the Son's Sacrifice and the Holy
            Spirit’s Hope, appear in you Offer the Holy Trinity your work and
            prayers. Enjoy the good things of this world, as something
            ephemeral. Bless and thank God’s infinite generosity that sends them
            to you. During this time of preparation you should meditate God’s
            word with deep humility to be accepted in Heaven by your God Father,
            He who knows your hearts. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 4th, 1996</h6>
          <p>
            Dear children: <br />
            You are in the world because of God’s love. <br />
            Follow God and convert yourselves during this time of great Mercy.{" "}
            <br />
            Open your eyes to the Light of the world, because he is the
            Redeemer. <br />
            Because a time will come when you will be called to trial and after
            that, there will be abysses separating what is good from what is
            wrong. <br />
            My children, Heaven is waiting for you. Come to my Immaculate Heart
            and I will guide you toward God. I love you intensely. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 5th, 1996</h6>
          <p>
            Dear children let God’s Love and Peace be with you. <br />
            I have come today to tell you that you should remain together in
            prayer. In order to combat the wicked enemy who is trying by all the
            possible means to take away the peace from you, especially the peace
            of homes; sinking them in discouragement and anguish, to take them
            away from the Love of God. Pray in the streets with the Holy Rosary
            relieving Mary’s Immaculate Heart. <br />
            The Rosary is your salvation board. <br />
            Pray strongly one for the other, with charity for the brother that
            suffers. <br />
            Put all your hope in God. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 6th 1996</h6>
          <p>
            My sons: <br />
            Remain attentive to God’s Love. <br />
            I have come today to tell you, what God wants from this town. Be
            faithful as his children, knowing how to be a true Christian. <br />
            Bless the Father; He is patient with you, with his Infinite
            Generosity. Listen to God’s Word as it is a Word of Eternal Life;
            and work according to it if you don’t want to fall down. <br />
            Those who abandon God’s right road will drag heavy chains and the
            light will not shine in their hearts. Grow my children in his Holy
            Wisdom and you will be tied to your God. Teach this. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> March 6th, 1996</h6>
          <p>
            "Consecrate yourselves to the Eucharistic Heart of Jesus; it is an
            urgent call of God’s Love. Be obedient my children I am God’s
            Mother." <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 7th, 1996</h6>
          <p>
            God says, "Be Saint", let it happens. My children pray for this
            intention.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 8th, 1996</h6>
          <p>
            Dear children: <br />
            Raise your eyes to Heaven and ask God in his Divine MERCY for
            regretting hearts. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 8th, 1996</h6>
          <p>
            Don't faint! Don't allow your knees to bend before the spirit of
            evil. God wants your conversion. Fast and do penance. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 9th, 1996</h6>
          <p>
            Dear children: <br />
            Be responsible for your Christian conscience; in order to live the
            true freedom that God has given you. Live the Gospel according to
            the Love. Help the others in the Love and in this way each one will
            receive the necessary in order to remain on the road. My children
            you should pray for this intention. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 13th, 1996</h6>
          <p>
            All of you are called to the loving encounter with your Father God,
            teach this. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 14th, 1996</h6>
          <p>
            My children: <br />
            I exhort you to look at the wonders of Father’s creation. Blessed
            and adored is his Saint Name, He who created everything with his
            Immense LOVE. <br />
            Be Regretful! <br />
            Return to God’s flock and you will live. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 15th, 1996</h6>
          <p>
            Adore the Holy Sacrament; adore him with your heart, with your soul
            and with your whole being. In this way ask for what you need with
            trust, and my dear children you will receive what you need to be
            worthy children of God. Live your lives with whom is Infinite Love,
            present among you in the Holy Sacrament. <br />
            Come closer to his Table and eat from him. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 18th, 1996</h6>
          <p>
            Dear children: <br />
            Don't look for material comforts; look for comfort in the prayer.{" "}
            <br />
            Pray with faith in the middle of difficulties to have faith in God.{" "}
            <br />
            Live with hope in your hearts. Find shelter in my Immaculate Heart
            and you will succeed. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 19 1996</h6>
          <p>
            Praised be the High one! <br />
            My children, I ask you during this time of conversion to meditate
            about your lives, below the light of Gospel, because it is a Word of
            life and Holy Wisdom. <br />
            Look at your consciences and be in peace with God. <br />
            Lift the spirit toward God with true contrition from your hearts.{" "}
            <br />
            Open your hearts to Jesus' Eucharistic Heart! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 21st, 1996</h6>
          <p>
            During this day I had a vision of Jesus' in prayer. It is night time
            and there are many stars in the Sky. <br />
            A voice tells me: He knows his sheep! I understand this inside my
            heart. <br />
            God knows all of us and each one of us, during different times and
            circumstances of life. <br />
            The good Shepherd is our hope. HE looks for us, HE knows us and HE
            looks at us from a time of Eternity. He calls us. He who hears him
            comes closer to his spirit of Love and He remains in us with his
            LOVE. <br />
            PRAYER <br />
            Saving Soul of Jesus Christ, consume my soul until the last drop of
            desire for myself and satisfy it with the fervent desire for Your
            Love, for the souls. <br />
            Let the drops of You Redeemer Blood fall over my heart, transform it
            and take it toward your Divine Heart. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 26th, 1996</h6>
          <p>
            Dear children: <br />
            I have come today to visit you, with the mission of taking you near
            Jesus, my Divine Son. Listen to my words and practice them with
            integrity and awareness, put your hearts under my command so that
            they can penetrate you with the light of the Divine Spirit and you
            get to know JESUS CHRIST, your Savior.
            <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 27th, 1996</h6>
          <p>
            If you want a world full of love "LOVE GOD ABOVE EVERYTHING". Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 2nd, 1996</h6>
          <p>
            María my daughter: <br />
            You should support all the tests with a great love for Crucified
            Jesus. The grace of God will be with you. <br />
            Let the fruits of your heart be given to the neediest souls, when
            you are in prayer. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 3rd 1996</h6>
          <p>
            My daughter: <br />
            Raise your heart toward my SON'S Cross to understand the whole
            mystery of his Love. <br />
            Remain in the Cross next to Jesus and your heart will be filled with
            blessings. <br />
            This is God’s promise. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 4th, 1996</h6>
          <p>
            JESUS says: <br />
            Look at me and adore me in my Holy Eucharistic Heart, you are in ME,
            when you eat My Body and you drink My Blood my infinite LOVE is in
            you. <br />
            Holy Mary says: <br />
            Through the miracle of the HOLY SACRAMENT, you penetrate in the
            intensity of the TRINITARIAN LIGHT.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 5th, 1996</h6>
          <p>
            My daughter: <br />
            To give yourself away to the mystery of the Cross is to convert
            yourself. When you hug the Cross because you love Jesus, bitter
            things become sweet, pain becomes joy, desperation becomes peace,
            and hate becomes Love. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 5th, 1996</h6>
          <p>
            At the feet of the Cross and in cruel agony, God’s Glory received a
            painful Mother, while her Heart was opening up.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 7th, 1996 (Resurrection Sunday)</h6>
          <p>
            Glory to the Power of God! <br />
            Glory to the Holy Spirit! <br />
            Be happy and Rejoice yourselves in the Resurrection of God! <br />
            Glory to God! <br />
            Glory to God! <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 8th, 1996</h6>
          <p>
            My children: <br />
            Convert yourselves! To God permanently, be like Jesus, and in this
            way those who look at you will recognize in you a true Christian.{" "}
            <br />
            Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 9th, 1996</h6>
          <p>
            Feed permanently from God’s Word, and try always to do what he
            wants. <br />
            All the time that goes by without lifting your eyes toward Heaven is
            a wasted time. <br />
            Amen. Hallelujah. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 10th, 1996</h6>
          <p>
            My children work with happiness in the fields of God, because a time
            will come when you will pick up what you have sowed. <br />
            Be humble and perseverant while you ask for God’s Grace. <br />
            Hallelujah. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 13th, 1996</h6>
          <p>
            (Today, I saw the Holy Virgin in deep sadness and anguish, dressed
            in white and her perfect face seemed to be bathed in perspiration).
            My children: <br />
            I have come today to ask you to pray, and pray with great urgency
            for the Peace of the world, as it is seriously threatened by the
            terrible iniquity of God’s enemy's. <br />
            Trust my Immaculate Heart as it will guide you in the middle of
            terrible tribulations. I will be your Guide, don't move away from my
            guide, don't separate from the Holy Rosary and pray permanently with
            it, I am your Mother and as a Mother I am speaking to you. <br />
            Today’s message is very hard and difficult to understand by those
            who live forgetting God’s presence, and even by those who having
            conscience of God live unworried about saving their souls, living
            according to the flesh and the world. <br />
            Terrible things will wait for you my children if you don't return
            your eyes to God, the tremendous punishment that God will send is
            about to start. <br />
            I will reveal you a part of it and I will do so to take you to
            prayer and sacrifice. In this way you will have some hope to
            mitigate it with your prayers. This punishment is terrible. This is
            a warning full of GOD'S LOVE toward humanity. <br />
            Many religious souls will fall and they will move away from God’s
            road to live in the warmness of the world, the priests that stay
            won’t be different from the worldly ones, they will follow the way
            that will take them to the apostasy, nuns will also follow this road
            and many good souls will get lost because of this. The world without
            religion and without God will be the house of wild beings and
            animals, and they will change the human physiology, in this way the
            body will look like the souls. These terrifying humans transformed
            into Satan’s pupils will take advantage from the havoc due to the
            big and imminent punishments falling over the world. They will
            pursue the good ones in ferocious hunt. There won't be any
            difference of sexes, and for a period determined by God, Satan’s
            Kingdom will reign. But my IMMACULATE HEART will separate the
            darkness and the horror from my consecrated children. God will wait
            for the conversion toward my Immaculate Heart until the last moment,
            so that everyone will have the opportunity to survive and to receive
            the pardon of God’s INFINITE MERCY. Pray, pray with intense Love.{" "}
            <br />“ Holy Eucharistic Heart of Jesus, in you I trust."
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 19th, 1996</h6>
          <p>
            Don't look for a remedy for your wrongs, in the world. Stick to the
            Holy Rosary! <br />
            The Rosary has been given to give you comfort and happiness. <br />
            God is pleased when you praise him with simple devotion. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> April 24th, 1996</h6>
          <p>
            Dear children: <br />
            I have come to teach you the way to Love, Jesus. <br />
            He is Road, Truth, and Life, and he who loves him truly won't fall
            down. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 25th, 1996</h6>
          <p>
            Dear children: <br />
            Believe in God and you won’t be afraid of anything. <br />
            Accept with Love all the things God has to send you. <br />
            You have life because of His Infinite Love and Holy Will; and this
            life will last until eternity, if you love God above everything. God
            didn’t create anything in vain, but the things of this world are
            vain. <br />
            GOD'S INFINITE LOVE lives in you my children, purify yourselves
            leaving your sins behind, Soon!. Go to the Holy Church looking for
            my Divine Son Jesus and you will find him, Oh! My sons, you cannot
            understand yet how much your God loves you. If you would know his
            LOVE, you would live with joy. Learn! My sons and put peace in your
            hearts. <br />
            Convert yourselves soon!. <br />
            I love you and I bless you. <br />
            Amen. Amen. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 30th, 1996</h6>
          <p>
            My children: <br />
            You have a great responsibility during this time; that is to pray
            for the peace and the love among men of the world. <br />
            If there is peace and love in you, there will be peace. <br />
            You will be able to love if you give yourselves away to a life of
            prayer, moreover, if you convert your lives into a prayer for God.{" "}
            <br />
            Give up all the excesses and don't sin. Open your hearts up to God’s
            word and allow yourselves to be guided by it. <br />
            Recognize God my sons, bend your knees in front of JESUS EUCHARISTY,
            and let him save you. <br />
            How much Jesus loves you! <br />
            Blessed are my children <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 3rd, 1996</h6>
          <p>
            What can afflict you my children? <br />
            You count on “God’s infinite Love". Convert yourselves and nothing
            will lack from your lives again. Pray to Heaven with perseverance!
            Be Jesus's disciples! <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 8th, 1996</h6>
          <p>
            (Holy Mary says) <br />
            "I am Your Mother and Protector" <br />
            My mission is to bring you near Jesus' Love. <br />
            I want to have all my children near my Heart. <br />
            Pray with faith and hope to your God. <br />
            I love you. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 13th, 1996</h6>
          <p>
            Today I had the following vision: <br />
            I saw a custody with the Holy Sacrament, she is in the middle of an
            immense light, She is surrounded by a crowd of Angels who are
            prostrated before her, at her feet I saw a rosary. After this vision
            I saw the Holy Virgin completely dressed in white. She was in the
            middle of the radiant light that always comes beforer her. She is
            wearing a golden crown on her head, her hands remain together at the
            height of her chest, and in them there is a Rosary that seems to be
            made of gold. She looks down and she says: <br />
            "I am the Holy Rosary's Queen I ask you to pray; make Sacrifice and
            Penance so that God’s Peace and Mercy go down over you. <br />
            Adore Jesus, your God, as the crowd of Angels adored Him in Heaven.{" "}
            <br />
            Pray the Holy Rosary every day, to be forgiven for the insults and
            sacrileges which are used to offend Jesus' Holy Eucharistic Heart
            and Mary’s Immaculate Heart. <br />
            Pray with your heart if you want to be healed spiritually. <br />
            The immense LOVE OF GOD is being given to you my children. <br />
            Pay attention to my wishes and convert yourselves soon (and then
            splitting her hands up and she blessed us) I bless You. Amen. Amen.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 15th, 1996</h6>
          <p>
            My children: <br />
            Invoke the Name of God!, don't follow the wrong road, come closer to
            the truth of the Gospel, road toward Eternal Life. <br />
            Pray to have your hearts joyful and full of Hope and to be blessed
            by the Love of the Holy Spirit. Don’t hesitate, because when you
            pray God is always guiding you. <br />
            Praise the Glory of God! <br />
            Hallelujah. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 16th, 1996</h6>
          <p>
            Blessed be the children who work according to the Holy Spirit’s love
            because they will succeed in their fight against the evil. <br />
            Remain in prayer and ask for the presence of God’s light by your
            side. <br />
            Convert my children to the Love of the HOLY SPIRIT!. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 19th, 1996</h6>
          <p>
            Saint is God in his immense Glory! <br />
            Saint is his Love that brought down Heaven for you! <br />
            And Saints are my children because they are God’s children. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 20th, 1996</h6>
          <p>
            Thank God my dear children, for all the things He has given you and
            trust his Kindness and Mercy praying with confidence at every
            moment. <br />
            He will listen to you all. <br />
            Be faithful because He will comfort you and He will make you
            stronger with his Spirit. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 22nd, 1996</h6>
          <p>
            My children give yourselves away to God with generous heart; do not
            be mean with your delivery. God knows all of you, and He will reward
            you according to your work. <br />
            Ask God for sanctity. <br />
            Thank God and Bless his HOLY SPIRIT. <br />
            Praise be to God.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 24th, 1996</h6>
          <p>
            Jesus tells me: <br />
            I want to be listened to and I order you to speak to the world about
            my "Holy Eucharistic Heart". Everyone should come closer to my
            Infinite Love with confidence. <br />
            Our Holy Mother says: <br />
            Return your eyes to Jesus Eucharistic, feed yourselves with the Love
            of his Holy Heart, listen to and love God. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 25th, 1996</h6>
          <p>
            Blessed you are my children!! <br />
            I have come today to bring you the Son, the Father and of the Holy
            Spirit’s blessing and love, in order to convert you. <br />
            I will be with you on the way to purification; I will be the light
            guiding your steps. Consecrate yourselves to Jesus' Eucharistic
            Heart and to Mary’s Immaculate Heart and the light will shine in
            your hearts. <br />
            The door is open my children, come to Me and I will be with you to
            go through the threshold. Thank you for listening to me. <br />
            I love you all. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 4th, 1996</h6>
          <p>
            Today the Mother has shown her Immaculate Heart. And she says:{" "}
            <br />
            This is my Immaculate Heart! Come closer to it! During these times
            of tests for the humanity, the light of my Heart will shine in the
            middle of the darkness. <br />
            I won't leave you; I will guide you with security with this light. I
            will melt the ice of many cold hearts with the heat of my Love, and
            in this way those who have reached God’s peace and those who have
            purified from all the filthiness and idolatries, will be called to
            share the Celestial banquet as true children of God. <br /> I love
            you Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 5th, 1996</h6>
          <p>
            Don't be afraid! No creature should feel abandoned from God’s hand;
            instead you should be encouraged to be strong Christians in the
            world. <br />
            Fight! Without fears because you have been chosen by God, and do
            everything on his Behalf saying thank you and praising his Love.{" "}
            <br />
            You are children of the light, and salvation is your destiny. <br />
            Teach God’s Word and pray with perseverance. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 6th, 1996</h6>
          <p>
            Daughter: <br />
            My Divine Son Jesus wants to be adored, praised and blessed by the
            whole earth, his HOLY EUCHARISTIC HEART. <br />
            Everyone should know God’s will. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 7th, 1996</h6>
          <p>
            To my young sons who are far from God’s Love. I tell you: Open your
            hearts! <br />
            Don't allow you to be contaminated by the spirit of the world, but
            to find satisfaction in God’s kindness. <br />
            Raise your eyes to Heaven and pray with your heart to the One who
            created all the wonders of the creation, and be aware of his
            Omnipotence, because he supports you with his Infinite Love. Feel
            his constant Holy Presence in your hearts. Blessed are my loved
            Children! Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 9th, 1996</h6>
          <p>
            Holy Mary says: <br />
            On this important day you should remain in constant prayer, raising
            your hearts toward God’s Holy Spirit and in this way you will be
            able to understand the greatness of the Holy Sacrament. <br />
            This is the biggest miracle of God’s love. <br />
            Praise be to God because of his great Mercy. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 14th, 1996</h6>
          <p>
            Praised be to God!, in his Holy Heart. <br />
            Dear children, I ask you to meditate sincerely about your lives,
            looking deeply at your hearts. This is a time of Love and Mercy and
            it sprouts from the Divine Heart without measure, all of you are
            called permanently. <br />
            Open your souls! <br />
            The Divine Heart is waiting for you; don't take a long time before
            answering. I love you and I bless you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 17th, 1996</h6>
          <p>
            My children you should purify your thoughts, always thinking about
            the Word. He who does this will have the Holy Spirit’s love in his
            heart. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 18th, 1996</h6>
          <p>
            He who has God in his heart has everything, because only God can do
            everything. Think about this my children. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 21st, 1996</h6>
          <p>
            Don’t be afraid my daughter, I trust you , I have put my hand on
            your hand. Teach what you have received with whole sincerity and
            simplicity, don't add anything, don’t remove anything from what God
            has sent you. <br />
            Consecrate yourselves to the Holy Eucharistic Heart of Jesus. <br />
            Pray and meditate my messages putting all your hope in God. <br />
            Many will be unbelievers but God’s strength won't abandon you, the
            effort will be great. The fact that I am so close to you is a very
            special Grace of God. <br />
            You have been favored. Let it give a lot of fruit.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 24th, 1996</h6>
          <p>
            María my daughter: <br />
            As you see me and you listen to me, I am close to all my children;
            make it known, everyone should come closer to my Heart with trust.{" "}
            <br />
            Glory to God! Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 25th, 1996</h6>
          <p>
            María: <br />
            Look at my face paying attention, because it is the image of the
            happiness in Heaven, because many warm hearts beat again with love.
            Teach this. <br />
            I am Mother of Hope I give to the one, who requests, <br />
            To the one, who searches To the one, who doesn't know. <br />I am
            the guide in the road toward Hope, and Jesus is Hope. Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 26th, 1996</h6>
          <p>
            Dear daughter: <br />
            Blessed you will be abundantly in the Holy Eucharistic Heart of
            Jesus. Saint will be your work and saints will be the people
            surrounding you. Saint is my Divine Son Jesus in his Holy promise.{" "}
            <br />
            Glory to Jesus! <br />
            Saint, Saint, Saint!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 29th, 1996</h6>
          <p>
            Today I tell you my children: <br />
            Love the Holy Church deeply. Pray together for the Holy Father to my
            Heart every day. Preach the Word and live it giving you away. <br />
            Live for Jesus Christ, with Him and in Him. <br />
            Join Jesus' Heart. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 2nd, 1996</h6>
          <p>
            God should be praised and blessed by all his creatures. Amen. Amen.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 3rd, 1996</h6>
          <p>
            Blessed you are my children! <br />
            Blessed are those who help and understand! <br />
            Blessed are those who are faithful to Jesus' Eucharistic Heart, my
            Divine Son. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 9th, 1996</h6>
          <p>
            My children don't be afraid because I am with you; I am Source of
            Light and Love. <b></b>
            I have separated the darkness from the Light of my Heart, so that
            you are not confused during these times of serious errors, walk
            holding my hand asking for an urgent conversion. Pray, Pray, Pray
            and start fasting twice a week. <br />
            Preach and live my messages, so that you are able to see great
            things in you and in your families. Be obedient my children!,
            understand this well. <br />
            I love you and I bless you. <br />
            Amen, Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 13th 1996</h6>
          <p>
            Praised be to God!, in all his creatures. Blessed are Heaven and
            Heart!. Blessed are my children!. Blessed are your Priests in the
            Holy Eucharistic Heart of Jesus!. Glory, honor and adoration to the
            Holy Eucharistic Heart of Jesus, my divine son, present in the Holy
            Sacrament. Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 16th, 1996</h6>
          <p>
            Blessed are my children! <br />
            Thank you for the love of your hearts!. I invite you to live Jesus'
            love with humble heart, to be favored by the Light of his Heart and
            to give a lot of fruit. <br />
            Be happy and thank God, who has looked at you and has chosen you
            among many others by the Glory and Blessings of his Sacred Heart,
            present in the Holy Sacrament among you. <br />
            You are Blessed, you will be Blessed. <br />
            Teach this. Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 17th 1996</h6>
          <p>
            Dear children: <br />
            Today I send you the peace of My Heart as it will open you the road
            toward conversion. I bless you with the peace and Love of my
            Immaculate Heart. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 29th 1996</h6>
          <p>
            Glory to God! <br />
            Praised be to God! <br />
            Dear children: <br />
            I will take you to God. Days full of happiness are waiting for those
            who trust my words. Blessed are my children. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 29th 1996</h6>
          <p>
            Dear children: <br />
            Blessed is God! <br />
            Bless Him with your hearts full of love for God. <br />
            Obey God! <br />
            Obey Him with your hearts full with love for God. <br />
            Blessed is God! <br />
            Bless Him all the time and thank Him for his LOVE. <br />
            If you adore his Divine Will you will feel that God’s Spirit remains
            in you. Amen, Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 1st, 1996</h6>
          <p>
            Adore God! <br />
            Just Adore God! My children look at Heaven where the Holy Trinity
            inhabits. Adore the HOLY SACRAMENT, and in adoration ask for his
            Holy Presence. God is Love! <br />
            God can do everything because his Love is infinite. I Bless you.{" "}
            <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15th, 1996</h6>
          <p>
            "I am your Mother of Heaven!" <br />
            I am in Heaven in body and glorious soul. <br />
            My children, today, I have come especially to you because today is a
            day of victory of my Immaculate Heart that lives and reigns forever
            next to the Holy Trinity. <br />
            Glory to God! <br />
            Praise is God’s Glory! <br />
            Bless God today, praise his greatness. <br />
            Put your hearts next to the Eucharistic Heart of Jesus. <br />
            My messages should be meditated, don't keep them in a drawer, read,
            meditate and begin to pray to the Holy Spirit so that He can turn
            them into a reality in your lives. <br />
            Let Jesus' Love and Peace reign in your hearts, I bless you
            abundantly. <br />
            Amen Hallelujah, Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 17th, 1996</h6>
          <p>
            My children: <br />
            Pray to the Holy Spirit; offer him everything you do every day.{" "}
            <br />
            If you pray you will receive holy inspirations for each thing you
            carry out. Believe, be Saints, be Jesus's true temples. <br />I
            bless you. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 18th, 1996</h6>
          <p>
            Dear children: <br />
            Don't look for the vain wisdom of the world, but the Light coming
            from God, where God’s infinite and eternal wisdom lives. <br />
            You have everything because God is with you in the HOLY SACRAMENT."{" "}
            <br />
            Put yourselves in attitude of prayer before God as needy children.{" "}
            <br />
            Experience this grace because it is hope. <br />
            I love you and I bless you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 19th, 1996</h6>
          <p>
            My sons <br />
            Praise be to God! <br />
            Return to God’s way!, because through it you will certainly reach
            God’s Kingdom. <br />
            I am your Mother of Heaven and I love you. I have come to call you
            to a greater life of prayer, to start liking the things of Heaven.{" "}
            <br />
            Begin to pray with me during this time because it is time of Hope
            and Mercy. Don't miss this moment, I bless you. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 22nd, 1996</h6>
          <p>
            Get up my children! <br />
            I am God’s Mother <br />
            "Queen of Heaven and of Earth!" <br />
            Consecrate you all to Mary’s Immaculate Heart and in this way I will
            be Queen of your hearts. If you consecrate yourselves, a powerful
            force will join you. I will transform you inwardly. <br />
            I will be permanently with you in your lives and Christ's Light will
            shine in you. Pay attention to my words to let the seed grow and
            give a lot of fruit. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 26th, 1996</h6>
          <p>
            Pray my children. Rise prayer to your God at the beginning of every
            day. Seek for protection in your prayer. <br />
            Put yourselves and your families in Jesus's hands. Ask for God’s
            protection. Be aware of the wicked one who will try by all possible
            means to take you away from God, putting fear and depression in your
            hearts. <br />
            Be strong in your Faith by means of daily prayer. <br />
            Praise be to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 27th, 1996</h6>
          <p>
            I love you my sons and I come as fast as I can to comfort you when
            you come closer to me with trust. You have a powerful means to come
            closer to my Heart; and it is by means of the Holy Rosary's prayer.
            Praying this pleasing devotion you can get Graces. <br />
            Ask for what you need my sons! <br />
            Ask for the conversion of your hearts and everything else will be
            granted. <br />
            I bless you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 30th, 1996</h6>
          <p>
            My children: <br />
            Be true Christians; be aware of what this really means. <br />
            Open the Holy Gospel and get to know God’s Mercy towards you. Let
            the Holy Spirit work in your hearts. Nobody survives alone, but due
            to God’s Mercy. <b></b>
            Praised is my Divine Son Jesus! <br />
            Praised is forever! <br />I bless you Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 2nd of 1996</h6>
          <p>
            Sons: Let charity be so necessary in your lives as the water you
            must drink. Preach this. Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 3rd, 1996</h6>
          <p>
            Praise be to God! <br />
            Be Perseverant and humble. <br />
            Invoke God!, with perseverance Be decided to do good things and to
            avoid bad things. <br />
            Trust God! He will protect you: Raise your hearts, join his Sacred
            Heart. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 4th 1996</h6>
          <p>
            My children convert yourselves. I ask you to do this! Return to God
            as it is time of harvesting. You are blessed today. Amen. Amen.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          September 5th, 1996 Sons light your hearts with love, praying
          continually. <br />
          Offer fasting and sacrifices to have Peace in the world. <br />
          I want you to be small instruments of God’s love. Complete these saint
          orders I’m asking you. Pray all of you the Holy Rosary, bend down
          lowly and ask for Peace and Love in the world. <br />
          If you pray with your heart, peace will enter in your lives and in
          your families and God’s love will become visible in you. <br />
          Don't be afraid! I will always be with you, praying with you. <br />
          I am God’s Mother. I am your Mother. You are blessed!. <br />
          Amen. Amen. Amen.
        </div>

        <div className="col-12 mt-5">
          <h6>September 7th, 1996</h6>
          <p>
            Be humble my children! <br />
            Humble of heart. <br />
            Regret and admit you are to be blamed. <br />
            Open your hearts! Go toward Jesus' encounter. <br />
            Nothing can be more beautiful than a soul in GOD’S GRACE. <br />
            Jesus loves you in his Infinite Mercy. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> September 8th, 1996</h6>
          <p>
            My dear children: Today I have come especially to bless you and to
            tell you that my Heart of Mother is very happy, because many of you
            have begun to walk with me. <br />
            You are chosen to grow in Jesus's love, due to his Glory and
            Blessing his Name. <br />
            Many difficulties are waiting for you but with my help you will be
            able to do everything. <br />
            Invoke His name in prayer and you will experience His Mercy, and so
            immense it is that it will be difficult for you to imagine. <br />I
            bless you. And I saw the Mother lifting her right hand with her
            Rosary, and she blessed us looking thoroughly down and smiling
            sweetly.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 11th, of 1996</h6>
          <p>
            Sons: Be like children! <br />
            In order to allow the Holy Spirit to start working in you. <br />
            Be helpful and merciful with those who suffer. <br />
            Open your hearts! <br />
            Don’t let charity finish, live always in love, and in this way you
            will be known in Heaven. God is infinite LOVE! <br />
            Preach this. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 13th 1996</h6>
          <p>
            Today while I was in prayer I saw the Holy Virgin who full of great
            splendor and glory came down with Angels from Heaven, she was
            dressed in white, a blue kerchief and a white veil. She had her
            hands in attitude of prayer and a slight smile in her beautiful
            face. <br />
            My soul raised before the solemnity of the vision. A star shining as
            the sun appeared in front of the Holy Virgin. The Virgin knelt down
            later in deep adoration, and then in the middle of a golden light I
            could only see the HOLY HOST and Jesus' wounded Heart and the Holy
            Virgin’s voice said: <br />
            "Blessed and adored is the Holy Eucharistic Heart of Jesus." <br />
            "Blessed and adored is the Holy Eucharistic Heart of Jesus." <br />
            "Blessed and adored is the Holy Eucharistic Heart of Jesus." <br />
            After that our Mother said: <b></b>
            "I AM THE INMACULATE MOTHER OF THE DIVINE EUCHARISTIC HEART OF
            JESUS" I asked HER: Do you want to be named in this way? And She
            said: "Yes, this is how you will know me." And then with a sweet
            smile she raised her hand she blessed us and she ascended.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 15th, 1996</h6>
          <p>Our Lord says: "If you want to be Mine come to Me."</p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 16th, 1996</h6>
          <p>
            Sons: "Don’t worry about mundane things, enjoy the things from
            Heaven." Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September17th, 1996</h6>
          <p>
            My sons: <br />
            Pray the Holy Rosary with Love Offer this to my Immaculate Heart. In
            this way you will reach wisdom, God’s things, you will know me and
            you will know God. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 18th, 1996</h6>
          <p>
            Praise be to God! <br />
            Persevere in the prayer and doing good work. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 24th, 1996</h6>
          <p>
            My sons: <br />
            "I invite you to celebrate this party praising God". And I exhort
            you to open your hearts to his Love. Pray to the Holy Spirit and he
            will give you Peace and strength now. I am Jesus' Mother and I bring
            you the Light of Hope. Blessed are my children. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 25th, 1996</h6>
          <p>
            Blessed are my children! <br />
            Blessed are those who live according to the Word of God! <br />
            Blessed are those who overcome all the tests because they love his
            Name! <br />
            Blessed are those who reject the prince of the world and are
            faithful to the Lord! On this special day I encourage you, my
            children, to walk in hope, and JESUS is Hope. <br />
            Purify your hearts and live as true children of God, loving God
            above everything. <br />
            I will always be with you I love you intensely. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 2nd, 1996</h6>
          <p>
            My children: <br />
            I’m going to produce a town full of love to God. <br />
            You should always work well and reject the wrong. You should
            constantly bless the Name of God and bless everybody in the Name of
            God and in this way God’s Peace and Love will always shine, the
            peace and love that are always among you, present in the Holy
            Sacrament. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 3rd, 1996</h6>
          <p>
            My sons don't make my Heart feel sad persevering on the wrong road.
            The Lord who is your God is too offended because of many and
            abominable sins that you make daily and there are some who never
            feel regret for doing so. But because of his Kindness and Infinite
            Mercy God is patient with you. Convert soon my children! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 7th, 1996</h6>
          <p>
            There is no better decoration for the soul, mainly for the soul in
            God’s Grace than you honoring me with the Holy Rosary's daily
            prayer. <br />
            And every time you pray my children, I am very close, and I
            intercede before Our God Our Lord for you. Blessed is God! <br />
            Blessed are my children!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 10th, 1996</h6>
          <p>
            My children: <br />
            Don't offend our Lord any more! <br />
            You don't take part in Christian life. <br />
            You permanently look for mundane satisfactions which convert you in
            sterile Christians, because in those vain pleasures you don't meet
            my Divine Son Jesus. <br />
            To live thinking about vain things leaves in your hearts tremendous
            holes which are impossible to fill. Return your eyes to God!. <br />
            Lord is all yours and he is waiting for your true conversion. <br />
            Give yourselves away to God and trust Him. He is your strength.{" "}
            <br />
            I love you all of you. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 12th, 1996</h6>
          <p>
            The Holy Virgin says: <br />
            My Heart remains sad, because many of you are far away from the
            Merciful Love of God. Although they are being constantly called.{" "}
            <br />
            These children have closed their ears and their eyes and nothing
            touches their hearts, they are hard and cold. But my Immaculate
            Heart’s love will insist till the end. <br />
            My children pray for the others and for you. <br />
            Praise and bless be to God. <br />
            I love you all. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 13th, 1996</h6>
          <p>
            Preach my messages, be obedient and live in peace with everybody.{" "}
            <br />
            Praise the Divine Providence and thank all its benefits. <br />
            Pray and fast because you love Jesus and his Holy Mother requesting
            for urgent conversion and Peace in the world. <br />
            Be humble and perseverant when praying for the Peace of the world.
            Pray the Holy Rosary for these intentions and do it every day.{" "}
            <br />
            Don't take a long time to preach my messages. <br />
            I love you and I bless you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 18th, 1996</h6>
          <p>
            I ask you for open and generous hearts, in order to understand this
            special grace that Jesus Savior is giving you. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 19th, 1996</h6>
          <p>
            Dear children: <br />
            Today I want to guide you toward Love. <br />
            I want to offer the Love of my Immaculate Heart. And through it I
            will take you to Jesus' Divine Heart. Give your Mother your hearts
            and I will take you to total conversion. <br />
            Give God glory! <br />
            Praise be to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 20th, 1996 (in the morning)</h6>
          <p>
            Dear children: <br />
            My Heart is very sad because many hearts are hard and cold and
            cannot receive GOD’S LOVE. These hearts cannot be moved by anything
            and they only pay attention to their own interests. <br />
            They are full with vanity, longing for all the honors of the world,
            dressed in stone. If you knew how big my suffering is for these
            children, who damage themselves, not being docile to the Holy
            Spirit’s love. <br />
            Listen to God’s call and convert yourselves, every day, every hour,
            every minute and every second, and Your Father of Heaven will listen
            to you when you invoke Him. <br />
            Blessed is God! Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 20th, 1996 </h6>
          <p>
            (in the afternoon) <br />
            Pray, Pray, Pray, for all those who are far away from God’s love.{" "}
            <br />
            Preach and live my messages opening your hearts. <br />
            Think deeply about them. <br />
            You are all my children and I want to convert you in true servants
            of God. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 21st, 1996</h6>
          <p>
            My children escape from materialism and prefer God’s things because
            they are sober and simple. The more you pray to the Holy Spirit the
            simpler your lives will be. And God’s Peace and Love will live among
            you. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 25th, 1996</h6>
          <p>
            My children: <br />
            Pray the Holy Rosary every day! Ask for the souls who are far away
            from God’s love. <b></b>
            It is necessary to pray day after day to rescue these souls who are
            submerged in sin. Pray for the ill people and the heart-stricken
            people and indeed you will be instruments of God’s Love in the
            world. <br />
            On this special day many children are looking confidently at my
            maternal Heart. And my Heart listens to the children, all of whom
            love me and trust my powerful intercession. But I tell you: Everyone
            is heard by the Holy Heart and today you will be especially
            comforted. <br />
            I, your Mother, have come to strengthen you in the Love for Jesus.{" "}
            <br />
            Obey my commands, be docile to fulfill my desires and I promise you
            a radical change in your lives. "Follow the Lord". He is God. <br />
            You are blessed. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 26th, 1996</h6>
          <p>
            My children: <br />
            Do not utter many words, but a few and truthful ones, founded in the
            Holy Gospel, to please God and to defeat the enemy. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 27th, 1996</h6>
          <p>
            My children: Praised it is God! Praised it is the Glory of God! God
            has prepared your hearts, to receive this great manifestation of his
            LOVE. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 5th, 1996</h6>
          <p>
            For you my children those who take heavy crosses, I tell you that
            you should have hope in God. Don’t let your strength decrease, don't
            put your arms down, be perseverant in the prayer to the "Holy
            Eucharistic Heart of Jesus". Look at Him and offer him all your
            sufferings and hardships, and indeed you will be alleviated and
            comforted by his LOVE. Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 6th, 1996</h6>
          <p>
            My children pray for those who still have their hearts closed and
            pray for those who remain erect and satisfied with their empty
            lives. <br />
            How many of my children insist on the wrong way! <br />
            Pray because God can demolish those who are proud and look again as
            your Savior. <br />
            Pray and purify your consciences. Don't waste time. Bless the time
            while God’s LIGHT remains with you. Thank God for his immense Love.{" "}
            <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 7th, 1996</h6>
          <p>
            Dear children: <br />
            I am praying permanently for you I intercede for you before the Holy
            Trinity and the enemy will not perturb your hearts. <br />
            I pray because I want you to know the Lord and to be aware of JESUS
            CHRIST real presence IN THE HOLY SACRAMENT. <br />
            I pray so that you are able to make present God’s Kingdom in your
            lives. <br />
            My children nothing will be possible without The Lord, and all of
            you will get everything with Him. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 8th, 1996</h6>
          <p>
            Blessed are my children! <br />
            Blessed are abundantly those who listen to God’s Word and practice
            it. <b></b>
            Blessed are the families that are pleasant before God’s eyes. <br />
            Blessed are those who suffer and the poor and disabled ones. <br />
            Blessed are those who bless God’s name! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 9th, 1996</h6>
          <p>
            Dear little sons: <br />
            Visit God! <br />
            Your hearts should remain in silence in front of the Tabernacle.{" "}
            <br />
            And He will teach you. <br />
            Think about this. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 12th, 1996</h6>
          <p>
            My sons: <br />
            Today I want to invite you to pray at every moment of the day. As a
            loving Mother I want to take you through the way to God, it will
            lead you to Heaven. <br />
            Open your hearts! And I will guide you to a meeting with God. <br />
            If you don't convert it is because you pray just a little or nothing
            at all. <br />
            How great is my Divine Son's Love! He is willing to forgive the
            sorry sinner. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 13th, 1996</h6>
          <p>
            My sons: <br />
            Live according to the Holy Gospel, doing good things and hating the
            evil. Since all the good things come from God and all the wrong
            things come from Satan. <br />
            Don't hurt anybody in any way because God receives the pain you are
            trying to cause to your brother. The enemy will try to make you
            fight and he will try to divide you, he will try to sow hate
            nowadays. That is the way in which the clever enemy will try to
            remain among you. <br />
            My dear children, that is why I am asking you to pray permanently,
            in order to recognize God’s love among you and my loving presence of
            Mother. <br />I invite you to a profound reconciliation with God,
            Don't allow yourselves to be cheated by the pride. Pray and start
            fasting to strengthen yourselves through the tests. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 20th, 1996</h6>
          <p>
            Children: <br />
            Pray the Holy Rosary and you will remain next to Me. <br />
            It is necessary for you to join my Heart through this simple prayer.
            I want you to understand this: if you pray just a little I am with
            you just a little time. If you are perseverant in your prayer you
            will feel how your love toward the Lord your God grows inside you.{" "}
            <br />
            It depends on you; I am waiting for you my sons. <br />
            Think about this. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 26th, 1996</h6>
          <p>
            I ask my Mother if she is happy with the booklet of “Messages "; I
            show it to her... She smiles with great happiness and she tells me:{" "}
            <br />
            My Heart is full of happiness together with the Angels of Heaven, he
            who owns this booklet with messages will own my Heart, because I am
            in each one of them. <br />
            You have attracted over your town a rain of blessings. <br />
            Praise be to God! <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 26th, 1996</h6>
          <p>
            Dear sons I want to share with you the happiness of my Immaculate
            Heart, with those who already know me and walk holding my Hand.{" "}
            <br />
            I want to reach in the hearts that still don't know me, to take into
            them a new hope. To take them to Christ Jesus' Light, I want to fill
            their lives with hope, to teach them the only way toward what is
            good. <br />
            To place Light in the darkness, happiness in the pain, health in the
            illness. I want to help them, my sons, Embrace my Pure Heart! I am
            speaking to you my children because I want you to start praying next
            to me. <br />
            God is waiting for your urgent conversion. I am with you; my mission
            as a Mother is to guide you through the road that takes you to God.
            Blessed is God! <br />
            Amen. Hallelujah. Amen. Hallelujah. (In a private message) ...Keep
            preaching my messages, and especially the devotion to the
            EUCHARISTIC HEART OF JESUS, don't be weak, every soul should be
            consecrated, and indeed everybody will receive the Infinite Mercy of
            His Heart. Preach your Consecration, warning that every consecrated
            soul will receive all the Graces coming out from God’s Divine Mercy.{" "}
            <br />
            This Consecration, to Jesus' Holy Eucharistic Heart will leave a
            seal of eternity in your souls and it will produce a great change in
            them. It will be the key to open the souls for conversion. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 27th, of 1996</h6>
          <p>
            Children: <br />
            Pray with a fervent heart. Don't allow anybody to drag you into
            darkness. "Loving God means praying profoundly for Him" I love you
            and I bless you. <br />
            Amen Hallelujah Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 28th, 1996</h6>
          <p>
            Dear children: <br />
            Today I invite you to prepare your hearts for Christmas. As your
            Mother I want to ask you to live this time with a different
            attitude. <br />
            Those who have good health, start fasting in penance and repair at
            least twice a week. And indeed when Christmas arrives you will enjoy
            peace and happiness. Do everything on behalf of God. <br />
            I bless you. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 29th, 1996</h6>
          <p>
            Sons: <br />
            Ask God for the gift of faith!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 30th, 1996</h6>
          <p>
            My children: <br />
            Let all your thoughts remain in Jesus. <br />
            Adore “Jesus“ in the Holy Communion. Give yourselves away completely
            to Him. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 4th, 1996</h6>
          <p>
            My children: <br />
            I am still waiting for many souls who are not decided yet. Trust my
            intercession! <br />
            My Heart is in fire with Love for you. <br />
            Don't be afraid!, come closer to me, give yourselves to my Heart. I
            want to be known more, more loved, more worshipped as the Immaculate
            Mother of the Divine Eucharistic Heart of Jesus. Preach this. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 6th, 1996</h6>
          <p>
            Praise be to God! <br />
            Blessed are those who listen to God’s word. <br />
            Blessed are those who listen to Me. <br />
            Blessed are those who fight to conquer the wickedness of this time.{" "}
            <br />
            Blessed are those who conquer them for love of God’s name. <br />
            My children pray and love Jesus' Heart, my Divine Son with all the
            things that make you who you are. You are Blessed. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 7th, 1996</h6>
          <p>
            My sons: <br />
            Pray next to my Immaculate Heart. <br />
            My Heart is the source where you will find the necessary strength to
            face all the difficult situations. You are blessed. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8th, 1996</h6>
          <p>
            Praised be to God! My children: <br />
            Today I want to pray with each one of you, to be in each heart who
            invokes me, rescuing the souls who are far away from the Divine
            Heart of Jesus. <br />
            I am blessed because I am Jesus' Immaculate Mother. My children
            glorify the Holy Trinity. <br />
            Glory to the Father! <br />
            Glory to the Son! <br />
            Glory to the Holy Spirit! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 11th, 1996</h6>
          <p>
            My sons: <br />
            Be Saint, as Saint is the Lord. <br />
            Sanctify yourselves in the Love. Consecrate your souls generously to
            the Lord, and indeed He will do what he needs with your hearts and
            you will reach the plenitude of his LOVE by means of this
            Consecration. <br />
            I love you and I bless you. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 13th, 1996</h6>
          <p>
            My Sons: <br />
            Pray for the people in pain. Be faithful to Jesus's Gospel because
            he is God and Savior. At this time of preparation for Christmas,
            open your hearts in a way that allows Jesus to be born in them and
            turn you into messengers of faith. Praised be to the Lord! Amen.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 14th, 1996</h6>
          <p>
            Praised be to God! <br />
            My sons, today, I want to grant you special blessings and to offer
            you the overflowing happiness of my Immaculate Heart. <br />
            I want to give you special Graces, Love, Peace, Strength so that you
            begin walking toward sanctity. I want you to be very happy on this
            road toward sanctity, and indeed you will experience the sacred
            happiness coming from God. <br />
            I want to help you to reach this happiness. <br />
            I’m waiting for you. <br />
            You are blessed! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 17th, 1996</h6>
          <p>
            Praised is my Divine Son! <br />
            Work with mercy my children. Be patient and try to understand the
            others. Every Christian should carry out this kind of duties. <br />
            Put peace in your hearts. <br />
            Escape from every division and problem; do not give place to the
            opponent, because you can be used by him. <br />
            Find shelter in the prayer and your spirit will be inclined toward
            the good. My sons you should try to defeat the meat and the world
            constantly. You will succeed, if you join Jesus in the Holy
            Sacrament daily." <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 20th, 1996</h6>
          <p>
            The Mother says: "Saint is Baby Jesus, present in the Holy
            Communion"
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 22nd, 1996</h6>
          <p>
            My sons: <br />
            Prepare a stable in your hearts, with sincere heart. <br />
            Be humble and simple as children in order to receive the Savior in
            your hearts. <br />
            Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 23rd, 1996</h6>
          <p>
            My dear sons: <br />
            The Baby Jesus can be reached by everybody. <br />
            Receive him with happiness and without weaknesses. <br />
            Bless the Father of Heaven. <br />
            Glorify Baby God present in the Holy Communion You are blessed!{" "}
            <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 24th, 1996</h6>
          <p>
            María: <br />
            On this unique and only day in the history of the world, we waited
            with Joseph trembling with love, we were very united and in profound
            prayer. That was the holiest moment in the world; God’s Son was
            going to be born. <br />
            Before being born Joseph and I adored him in the Tabernacle of my
            Pure Stomach, alive and Divine Host, inside my Being. <br />
            I am Jesus's first worshiper next to Joseph. Do you understand my
            daughter this immense gift to mankind from our Father in his
            infinite LOVE? <br />
            My Boy's Divine Heart beat inside my being, then Heaven opened up
            and the Father became present in the poor Stable of Nativity and he
            received his Son, then the small Baby God and Man was put in my arms
            and with Joseph, my husband, we adored the presence of the Holy
            Trinity. <br />
            Night of Love, of prayer, of adoration, of Peace. <br />
            Be saint daughter of my Heart in the name of the Son, the Father and
            the Holy Spirit. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 26th, 1996</h6>
          <p>
            Glories and blessings for the Holy Trinity! <br />
            Adore Baby Jesus because he is the Light of the world! <br />
            Wake up sons, and begin adoring the present Boy's Divine Heart in
            the Holy Communion. Feed yourselves from this Holy Bread and He will
            convert you. <br />
            Live this Communion in body and soul and indeed you will learn how
            to love. <br />
            I am God’s Immaculate Mother and your Mother. I am in my Divine
            Son's Heart; he who trusts Me will reach God. <br />
            You are abundantly blessed today.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 29th, 1996</h6>
          <p>
            Children if you want to deserve Heaven leave behind you the wealth
            accumulated in your heart. <br />
            There is so much wealth in some hearts that transformed into
            material goods they would throw a shadow over the richest people of
            the world. <br />
            Be humble inside your hearts my children; don't accumulate treasures
            that won't serve you in Heaven, because due to their weight you
            won't enter into it. <br />
            Be humble! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 30th, 1996</h6>
          <p>
            Sons: <br />
            During this time of conversion try that the arrogance and the envy
            don't turn your hearts into blind ones. Take care of this enemy
            because it is so harmful for your souls. You cannot deceive God.{" "}
            <br />
            Glorify God with humble heart. I bless you. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 31st, 1996</h6>
          <p>
            My daughter: <br />
            Pray, smile and bless all your siblings. Let God’s peace be your
            permanent company. Glory to God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 1st 1997</h6>
          <p>
            I am God’s Mother! <br />
            I have placed my eyes and I have put my Heart over my children of
            the world. <br />
            I keep all my dispersed children of the whole world in my Immaculate
            Heart. <br />
            I am with you because of God’s will, to exhort you to an urgent
            conversion. <br />
            My sons pray, pray don't leave the Holy Rosary. <br />
            Be blessed today and let God’s Peace, love and Blessings descend
            over all my children in the whole world. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 8, 1997</h6>
          <p>
            Dear children: <br />
            Find shelter in Me because I am your loving Mother. <br />
            Don't look for momentary solutions for your problems, thinking like
            the world thinks, because you would carry useless spiritual loads.
            Think about you as God’s children and Jesus Christ’s servants. Look
            at his Divine Eucharistic Heart, offer him all the love of your
            hearts and your load and problems will be alleviated and Peace and
            happiness will return to your lives. <br />
            I Love you. <br />
            Amen .Amen .Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 10th, 1997</h6>
          <p>
            My children: <br />
            Pray and fast! <br />
            Raise your hearts to Heaven. <br />
            Don't pay attention to the things which are not important, ask for
            strength and perseverance to pray. Don't forget the charity toward
            your neighbor, be aware of Good and be careful because satan appears
            lying and seducing you, to tempt you, if you pray his power won't
            reach you, I am praying for all of you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 19th, 1997</h6>
          <p>
            My children: <br />
            I am waiting for you! Day after day. Come to Me and find shelter in
            my Immaculate Heart, I want to spread my blessings over you. <br />
            The necessity of love grows in your hearts, because you my children
            live in a world where material things seem to be something essential
            if you want to be happy. <br />I have come to transform you inwardly
            with the heat of my Maternal LOVE, and you will understand the love
            of Jesus' Divine Heart.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 21st, 1997</h6>
          <p>
            My sons: <br />
            Get ready! During this time of conversion. Open your hearts with
            prayer. <br />
            Pray to the Holy Spirit in order to allow his Light and his Love to
            guide your steps. Wake up! And pray constantly and you won't fail.{" "}
            <br />
            Praise be to Jesus Christ! <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 24th, 1997</h6>
          <p>
            OUR PURE MOTHER VIRGIN MARY ALWAYS tells us: <br />
            I want to spread over you my children great Graces, I ask for your
            constant prayer, because this is time of conversion. <br />I have
            come to wake up God’s true love in you. Let God’s peace and love be
            with you and spread over the whole world. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 25th, 1997</h6>
          <p>
            My sons consecrate yourselves to my Immaculate Heart. <br />
            Preach this CONSECRATION. <br />
            Pure Mother I want to consecrate my heart, my will and my entire
            life. Take me to the Heart of your Divine SON JESUS, so that he can
            live in me. My Mother I want to be absolutely yours and from now on
            I will serve you faithfully in everything you ask me to do. <br />
            Be sweet company during my life, do not allow me to leave you, and
            at the time of death come for me, in order to enjoy eternity in your
            company. <br />
            Praise be to Holy Mother - Amen <br />
            "Blessed and praised you are my Mother for ever." Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 31st, 1997</h6>
          <p>
            Praise be to our Lord! <br />
            Blessed you are my children, I want you to pray together to the Holy
            Spirit because with the strength of the prayers you will be able to
            stop wars, hunger, suffering and natural disasters. <br />
            Don't leave your Christian lives, save time during the day to pray,
            remember my order, let the desire to pray to be born in your hearts,
            and pray with strength to God to do what he wants you to do, this is
            how satan will not be able to gain more souls. <br />
            Glory to God! Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 25th, 1997</h6>
          <p>
            I was praying the Holy Rosary, I was praying in front of the image
            of the Holy Virgin of the Rosary and on her forehead I saw a dark
            shape, like a cross. <br />
            After the Holy Communion, the Holy Virgin told me: <br />
            Daughter: <br />
            The cross of ash that you see on my forehead is a sign of conversion
            and penance that I request to all my children during this special
            time of Easter. <br />
            Be regretful for your sins and purify your hearts, do not waste
            these days without doing so. Get ready for the Lord! <br />
            He is calling you, go to his Holy Heart, and don’t offend him any
            more. On this special day I will bless you with the immense Love of
            my Immaculate Heart. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 1st 1997</h6>
          <p>
            (Solemnity of Corpus Christi) Being in prayer I saw Our Lord with
            great magnificence, glory and splendor. <br />
            He called me by my name <b></b>
            María: he said later, look at me... And I saw in his chest an
            impressive Heart of meat, red, bleeding and beating. I felt an
            immense heat as if I was inside a blaze that burned me completely.
            And at the same time a big beatitude raised my soul toward Him.{" "}
            <br />
            I understood that God, I don't know how, had introduced me in his
            Sacred Heart, there I felt God’s perfect light, and the sweetness
            and softness of his LOVE. <br />
            The Lord said: listen carefully to this command from my Infinite
            Providence. Adore me and honor me above everything to repair and to
            relieve the insults, forgetfulness and sacrileges committed against
            my Divine Love’s Sacrament in the whole world daily. CONSECRATE
            YOURSELVES TO THE HOLY EUCHARISTIC HEART AND TO MARY'S IMMACULATE
            HEART, THE WHOLE WORLD should be CONSECRATED. <br />
            The Adoration to the Sacred Sacrament should be known and
            advertised, as true devotion to my alive Heart and presence in the
            Holy Sacrament." <br />
            My Love for the souls is so great my daughter that I will open the
            doors from Heaven to everyone who receives me and pleases me. <br />
            I bless you my daughter with the strength of my LOVE.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 6th, 1997</h6>
          <p>
            (Solemnity of the Holy Heart) The Lord said: Be mine, all of you!
            Give yourselves away to Me. Trust Me completely! Come to the fire of
            my Infinite Charity
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 16th, 1997</h6>
          <p>
            Saints are my children in the Holy Eucharistic Heart of Jesus!!
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15th, 1997</h6>
          <p>
            Praised is the Lord! <br />
            On this very special day, I bless you my sons. <br />
            I am Jesus' Mother and your Mother of Heaven. <br />
            Be small and humble and consecrate to my Immaculate Heart today. My
            children Convert to the Lord! <br />
            Love everyone with sincere heart, let forgiveness be the Light of
            your hearts, and indeed God will bless you abundantly. <br />
            Give yourselves away my sons to the Love of the Divine Heart. <br />
            Consecrate to his Divine Heart, with a clean and pure heart. Pray my
            sons pray for this intention. Blessed and adored is the Divine
            Heart! <br />
            Remain in the burning Love of the Divine Heart. Saints you are my
            children. Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 29th, 1997</h6>
          <p>
            Praised is The Lord! <br />
            If men don't convert and they don’t listen to God, many wars and
            pests will fall over humanity, tell them to return to God, they
            should listen to his Word, they should pray the Holy Rosary every
            day; many hearts are very hard and many ears remain deaf to my
            messages. I want to be listened, pray for this intention... I will
            pray to God for your intentions. You are blessed daughter of my
            Heart. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 13th, 1997</h6>
          <p>
            Praised is Jesus Christ! <br />
            On this special day when you honor God’s mother I want to spread
            blessings over all my children, especially over those who suffer and
            those who are heart-stricken. <br />
            I want to comfort them and to encourage them with the Love of my
            Pure Heart. Come to your Mother, my little sons and all of you will
            be satiated in the shelter of my Immaculate Heart. <br />
            On these days I invite you to pray with your hearts. Pick it up in
            the Love of Jesus' Divine Heart. Pray to soften your rebellious
            hearts. <br />
            Read my messages, read them with pure heart, they are a powerful
            means to take you to Jesus' Holy Eucharistic Heart, where the
            Salvation and Sanctification of the souls are. <br />
            Turn into Jesu's true friends. <br />
            Preach this, my daughter; preach it to the whole world. Saints are
            my children! <b></b>
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 13th, 1997</h6>
          <p>
            Pray my sons, pray for the time that comes, consecrate your days to
            the Lord and pray to the Sacred Spirit asking for the Peace of the
            world. <br />
            Be obedient my sons. Convert yourselves! I love you and I bless you.{" "}
            <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 28 1997</h6>
          <p>
            Our Mother says: "I am among you" I bless you abundantly. Amen.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 1 1997</h6>
          <p>
            Today I saw the Lord while he was praying, He had red mantel, and
            his right hand supported a part of him and he supported himself on
            his Heart, I saw the wounds of his hands and of his feet full of
            light and his Heart with the radiant wound of pure light. Before
            HIM, I felt his Love, and an immense peace invaded all my being and
            turned me into nothing. <br />
            Then He said: <br />
            ¡ Don't be afraid in this great tribulation, it is necessary that
            the sick humanity returns to my Love and Mercy. <br />
            Dark and weak minds have lost the value and do not trust Me anymore.
            The enemy wants to lose them and their hearts are full of mundane
            interests, revealing against my Love and my Mercy, there is
            confusion in their divided minds. <br />
            They don't contradict the wrong, and they work against my Gospel. My
            dear daughter dive in the rays of my Mercy, I open them entirely for
            you... I saw the center of his Divine Heart and his wound. An
            immense heat invaded me and I began to perspire deeply and to cry
            with deep sorrow for my soul and I felt a big desire to love him
            more and to please him, I felt a burning desire to belong to him
            totally, and the joy of my heart amid the pain and the suffering
            were inexplicable, and a heroic strengh was captured in my being.{" "}
            <br />
            Then the Lord said: <br />
            Let everybody know the devotion to my Loving Eucharistic Heart,
            don't let this treasure pass by you. By means of you I want the
            whole world to adore my alive Heart within the Holy Sacrament.{" "}
            <br />
            Priests should consecrate and renovate the consecration to my Heart
            in Holy Mass, I promise They will receive aid and the necessary
            graces to be faithful to their Ministry and the strengh of my Love
            will be within them until the end. <br />
            There will be a big change in their hearts and their lives will be
            totally overturned to Me. This is the way it should be (and I saw in
            my vision that the written line is as an indelible stamp).
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8 1997</h6>
          <p>
            (Day of the Sacred Virgin Mary's Immaculate Conception) Praise be to
            Jesu's Divine Eucharistic Heart! <br />
            Be happy my sons and live in peace and harmony during this special
            day. I am God's Immaculate Mother, and I want to bless you
            especially today. Open your hearts to my Love! <br />
            Don't feel you have enough of it, do not just read or listen to my
            messages, live them intensely and with happiness. <br />
            Allow yourself to be driven by the Sacred Spirit, be strong in your
            prayer, I will be praying with you. <br />
            Allow me to penetrate your hearts. Trust my Love! I love you all.{" "}
            <br />
            Blessed you are. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 24 1997</h6>
          <p>
            My sons: <br />
            Praise and adore be to Little Jesus! <br />
            Do this until the end of your days. <br />
            Keep yourselves in perpetual prayer and adoration to God. Because
            from Him life flows abundantly. He is the Bread of true Life. Come
            closer to Him, as the Nativity shepherds did and you will be Safe
            and you will receive and Eternal Life. <br />
            It is impossible to remain in the darkness, if you come closer to
            the Light. The Light came to the world in my Pure Breast, and It
            will remain with you until the end. "I am God's Immaculate Mother"{" "}
            <br />
            Adore Little Jesus, adore him within the Sacred Sacrament. Glorify
            God! <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 1997</h6>
          <p>
            I see the Sacred Virgin wrapped in a great light, behind her I see a
            red Sky. She remains in attitude of prayer, I feel a light movement
            of her head and she tells me: <br />
            Praise be to God! <br />
            My children veil and pray to the Sacred Spirit, so that blind men
            can see, deaf ones can hear and disabled people can walk. <br />
            Veil and pray to the Sacred Spirit Veil and pray in order not to be
            confused during this time of great spiritual confusion. <br />
            Veil and pray to the Sacred Spirit for the youths, because young
            people are growing day by day in atheism. <br />
            They are as egg shells, if you hit them they crack, they break and
            they are hollow and sad. Return to God! <br />
            Allow the Sacred Spirit to act and you will be strong as rocks.{" "}
            <br />
            Allow the Sacred Spirit to win your hearts. <br />
            Amen Hallelujah Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 1 1998</h6>
          <p>
            Dear children: <br />
            Praise be to God! <br />
            Praise be to God's Sacred Spirit! <br />
            God should be praised, blessed and glorified! <br />
            Consecrate to the Lord every day of this New year, be humble and
            obedient to my calls. Trust just in the Lord., and give yourself
            away to the Sacred Spirit <br />
            My son Jesus is waiting for you to live in communion with the love
            of his Divine Heart and you will live. <br />
            Blessed you are my sons Amen. Hallelujah. Amen. Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 11 1998</h6>
          <p>
            My children: <br />
            I stay with you and my Heart is aching because thousands of souls
            get lost in the world and in spite of my requests they remain in the
            darkness. <br />
            Pray intensely during this time of Mercy, especially those whose
            hearts are hard, move those souls away from the darkness ,
            illuminate them with the Sacred Rosary's prayer. Pray for this
            intention and you will be as lamps amid the darkness. <br />
            I bless you especially today. <br />
            Glorify God! <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 25 1998</h6>
          <p>
            Blessed is God and praise be to his Sacred Spirit! <br />
            Pray for the Peace of the world my dear children. love every town,
            with deep love. Pray to the Sacred Spirit for your salvation with
            perseverance Preach the Lord's Gospel. <br />
            Believe in him and live him with stability so that your faith is not
            a vain feeling. <br />
            Be helpful those who work for God's Kingdom, look for mutual support
            and peace and happiness will grow in this way, they are signs of
            God's Love among you. <br />
            Adore and love more the Lord and you will grow in love to your
            siblings. <br />
            Return to the Lord and don't sin more! <br />I bless you all on
            behalf the Father, the Son and the Sacred Spirit's Name. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 25 1998</h6>
          <p>
            Today the Sacred Virgin appeared; the pure light that surrounded her
            and escorted her, made me truly understand God's Glory. <br />
            She said: <br />
            Praise be to God and his Sacred Spirit! <br />
            Jesus's Eucharistic Heart should be blessed! Pray and remain in
            prayer next to your Mother from Heaven. <br />
            "I am the Ark of the New Alliance" All the towns should praise and
            bless the Savior's Immaculate Mother. <br />
            When with my "Yes" The Divine Verb was embodied in my being, my
            Heart, penetrated the Divine Heart, and in sacred communion I adored
            my "Divine Son's Holy Heart." At this time the doors of the Sky
            opened up. "Return to God" My children, be happy. I bless you and I
            love you all. Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 12 1998</h6>
          <p>
            1º Sunday (Easter) <br />
            Today I saw the Sacred Virgin with an immense golden light
            surrounding her, her face almost transparent and great happiness.
            Brilliant rays of almost blue pure lights, left their hands, feet
            and heart, and she said: <br />
            Blessed you are my children: Imagine the joy of my heart before my
            Divine Son Jesus Christ's Resurrection. <br />
            Be happy today. <br />
            Glorify the Lord within your Hearts Glorify God! <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 8 1998</h6>
          <p>
            Blessed you are my children! <br />
            I am the Mother from Heaven and I have come down to guide you
            towards a true conversion. <br />
            Pray and Adore God present in the Sacred Sacrament, trust in Him
            totally. Pray deeply in front of him with withdrawal, that is to
            say, alone with Him, don't allow any other thought to go into your
            mind apart from being with Jesus , and you will be able to start a
            dialogue with Him, and you will be abandoned into his Heart. With
            this deep prayer to "Jesus's Eucharistic Heart" many lashes will
            stop. Pray with trust and do not be afraid, I will be with you.{" "}
            <br />
            I love you all. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 13 1998</h6>
          <p>
            Praise be to the Lord! <b></b>
            My dear children be faithful and don't abandon the true road, don't
            allow yourself to be confused by extravagancies. Read and meditate
            on his Holy Word and be Saint doing so. <br />
            I bless you all <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 30 1998</h6>
          <p>
            My Heart is sad because you don't convert, many souls walk lost and
            they remain outside the flock. My Immaculate Heart is crossed by
            swords, causing me a great pain. <br />
            Renovate your pact of fidelity with my Heart. Let your fidelity turn
            into prayer and the prayer turn into work. <br />
            Put yourself under the light of the Sacred Spirit He lives in you
            and you will receive everything from "him" and you will enjoy his
            Love. <br />
            Make everything for love to the Sacred Spirit. <br />
            Remain below the shade of Church. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 31 1998</h6>
          Dear children: <br />
          Today is special for the world, I have come to remove the bandage from
          your eyes and in this way to take you to trust more in God's power.{" "}
          <b></b>
          "Convert yourselves", Open up your hearts and I will be able to
          transform them. I am God's Mother and your Mother, I wish I would help
          you and take you towards the Sacred Spirit's light. <br />
          Pray together with my Immaculate Heart and Peace and Love will return
          to your lives. I bless you thoroughly <br />
          Glorify God! Hallelujah.
        </div>

        <div className="col-12 mt-5">
          <h6>June 14 1998</h6>
          <p>
            Bless the Holy Church <br />
            Bless God's Saint Name. Bless and adore Jesus' Sweet Heart present
            in the Sacred Sacrament. Sons, God is alive in the Sacred Sacrament,
            go to Him. <br />
            I love you intensely and I Bless you especially today. <br />
            Glorify God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 19 1998</h6>
          <p>
            (Day of Jesus' Sacred Heart) Dear sons: <br />
            Be faithful to prayer. Every time you pray, put yourselves before My
            Son's Divine Heart, who is present in the tabernacle. Ask for all
            your needs. <b></b>
            The prayer before Jesus's sacrament is powerful. <br />
            Say: <br />
            - Sacred and Divine Jesus's Heart , I believe you are here. <br />
            - I believe with my poor heart. <br />
            - I adore you Divine Host and I trust in Your infinite Mercy that
            sustains humanity. - I know that I am not worthy of you, help me to
            conquer the difficulties of this life. - Change my heart. <br />
            - Grant me this grace by means of Your Holy Mother's Immaculate
            Heart. - Praise be to Jesus's Heart. <br />
            Amen. <br />
            I bless you especially <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16 July 1998</h6>
          <p>
            Today the Holy Mother came with Little Jesus in one arm and the
            Sacred Scapular in the other one. She was smiling, as Little Jesus
            did and she said: <br />
            Pray my sons! with great perseverance to resist tribulations, keep
            in prayer together with my Immaculate Heart. <br />
            Pray and ask for your needs, on behalf of my Divine Son's Name
            Jesus, to the Father. <br />
            Keep firmly in prayer so that you have wisdom and receive Light and
            the Knowledge from the Sacred Spirit, which you will need during
            this time in order not to be deceived. <br />
            To pray is very important, because it makes you strong and resistant
            to combat the prince of the darkness. <br />
            Listen to me sons! <br />
            You are the means, pray With me, preach my messages so that the
            whole world knows God's Infinite Mercy. I will remain with you; I
            Love you intensely and I bless you especially today. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>26 July 1998</h6>
          <p>
            (At night) Jesus says: <br />
            He who honours my Mother, honours me. <br />
            Therefore I tell you that he who honours her really pleases me. I
            will go into him and I will eat with him. <br />
            Glorify My Heart doing this that I tell you. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15 1998</h6>
          <p>
            María: Tell to my children <br />
            Give yourselves away to this Mother! <br />
            You have hardened your hearts. <br />
            You have closed the doors. <br />
            Give yourselves away to this Mother, listen to my supplications with
            pure Heart. Clean your hearts, leave aside hate, envies, divisions
            among you, rivalries and other attributes, worthy of Satan's
            Kingdom. <br />
            I am your Mother, God's humble servant, humble intercessor. <br />
            Don't make my heart feel sad. <br />
            Repair the offenses against my pure Heart with Love! <br />
            Meditate on the lack of love, praying to the Divine Spirit. <br />
            Come to my Immaculate Heart, I am waiting for you. <br />
            Blessed you are! <br />
            Glory! Glorify God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 25 1998</h6>
          <p>
            My Children: <br />
            Pray to the Father permanently to repair the offenses that are
            continually committed against him, who is present in the Sacred
            Sacrament. <br />
            Pray and trust in the Eternal Father. <br />
            Offer all your good work and sacrifices for your siblings, those who
            have moved away from the Lord and remain indifferent to his LOVE AND
            MERCY. <br />
            Pray for youself, to receive the Grace of prayer, it is necessary to
            ask for your needs with perseverance to reach the Grace of the Sky.{" "}
            <br />
            I bless you all. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 September of 1998</h6>
          <p>
            Today I had a vision: <br />
            I saw a great door of a great brightness in the sky. <br />
            Angels' multitudes surrounded it, They were so white and so many
            that got lost in the distance. <br />
            They sang Glories and Hallelujah and they praised María's Name I
            Looked inside the great door and I saw a great field that seemed of
            wheat, and was bright yellow, it was surrounded and closed by a
            circle of light. From the centre of this circle of light a small
            Little Girl who had her little hands crossed above her chest arose.
            She seemed to be sleeping. The beauty of the Girl is so impressive
            that the angels themselves are overwhelmed looking at her. Her skin
            is pinkish and the perfection of her face is superior to the human
            kind. <br />
            I saw a very big and luminous Angel taking long sticks of gold
            finished with a beautiful and delicate flower. <br />
            The Angels took the Girl up and put her in her mother's arms. <br />
            After this vision I saw the Mother and smiling she said: <br />
            My dear sons <br />
            Praise be to God! and blessed you are, because you have me Glorify
            the Father Glorify the Son Glorify the Sacred Spirit
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 September of 1998</h6>
          <p>
            (Saint Virgin's Solemnity) <br />
            Saint is this town that honours me! <br />
            I bless you with my Heart during this glorious day. <br />
            This town is receiving great graces, graces that are spread over the
            world. <br />
            Come to my Immaculate Heart of Mother, I will light your road, I am
            the road for those who are lost, he who walks With me will never get
            lost. <br />
            I am the Immaculate Mother of Jesus's Eucharistic Heart I am a
            faithful Mother! <br />
            I love you all, Blessed you are. <br />
            Glorify God! <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14 September of 1998</h6>
          <p>
            Oh, my Divine Son's blessed cross! <br />
            My children: <br />
            Come to meet Me at the Cross feet. <br />
            The Cross protects you, blesses you, sanctifies you. The Cross is a
            rest for the soul. The Cross is Father's Love , Son and Sacred
            Spirit's love. <br />
            Praise be to The Savior!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 15 1998</h6>
          <p>
            Jesus says: <br />
            I am Jesus's Eucharistic Heart. <br />
            Come to Me, Oh thirsty souls of my Love, sinful, lukewarm and
            unfaithful souls. My Heart that was opened up by the lance, will
            remain open until the end. <br />
            Nobody will be rejected, all of you will be attracted. I will go
            down into all the hearts that receive me. <br />
            My wounded Heart is the door to MY LOVE and Mercy Oh weak souls come
            near the Light of My Heart. Do not be afraid, trust in me. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 25 1998</h6>
          <p>
            My sons: <br />
            Pray without interruption to Jesus who is your present God in the
            Sacred Sacrament. <br />
            Every time you pray in this way I am present, and my Heart will
            bring happiness. Meditate, meet God, converse with Him, and ask for
            your needs, ask and you will obtain Mercy. My sons, I am teaching
            you to know the infinite Mercy of Jesus's Eucharistic Heart. <br />
            Trust in Him, trust in Him completely, He is Host alive and present
            in the Sacrarium. Glorify God! I bless you abundantly <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 7 1998</h6>
          <p>
            Praise be to the Lord! <br />
            My children, adore God. Pray the Sacred Rosary with more devotion;
            as each mystery is a true meeting with God. <br />
            Pray and adore the Lord, asking for Peace and Mercy, days full of
            very hard tests are waiting for you. Men's sins darken the Father's
            Face. <br />
            My sons you don't understand how big God's Kindness is. Meditate on
            this, thank continually, Adore my Son's Eucharistic Heart, let your
            hearts be similar to Jesus' Heart. Praise be to Jesus's Eucharistic
            Heart. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 13 1998</h6>
          <p>
            Praise be to God! <br />
            Be blessed my children, be the Lord's humble servants during your
            lives. Be Patient during the tests and Merciful of Heart. <br />
            Convert yourselves into Witness of the Love of Jesus's Loved Heart.{" "}
            <br />
            Live next to Me, The Sacred Rosary sanctifies you with this simple
            prayer. Oh Mysteries of God! which bring those who are small and
            humble towards God. <br />
            Glory to God! <br />
            Amen Hallelujah Amen Hallelujah. <br />
            Then I saw a beautiful white dove full of light on my head and I
            felt these words. She writes: <br />
            I find joy in you my Lord! My tongue should praise and bless you.{" "}
            <br />
            My eyes should look for you and my hands serve you. br My soul rests
            in you. <br />
            The joy and happiness inside my heart is perfect in Your Saint
            Presence. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8 1998</h6>
          <p>
            The Sky has opened up today which is so special, to come to you
            small flock of the Lord. I am always with you sons, my silence does
            not mean absence. <br />
            I combat by your side, I watch over you night and day with tender
            Love of Mother. I pour abundant tears for the souls which move away
            from my Divine Son Jesus. NOBODY WILL BE TRANSFORMED WITHOUT FEELING
            DEEP DESIRE TO RECEIVE LOVING JESUS. <br />
            Look at Jesus' Sacred Heart, look at his Eucharistic Heart, trust
            Him, and the darkness will go back. I bless you all. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 1998</h6>
          <p>
            Praise be to the Savior! <br />
            María: I have come to share with you the joy and happiness of my
            Divine Boy's Birth. In the previous days before his coming to the
            world My Heart remained in immense peace. There were not questions
            inside my heart, only joy, peace and meekness. All my being
            abandoned to Him, in adoration to the Little God. <br />
            My husband's sweet look didn't move away from Me. I also noticed a
            great change in his noble face. In silence he assisted me with love
            and devotion. <br />
            The Heart beat announced the Little God's birth. An extraordinary
            and brilliant light sprouted from my bowels, this extraordinary
            Light was covering everything, it was very intense and brilliant.
            The whole cave of the Nativity was full with the presence of Angels
            who sang Glories and Commendations. I was lifted and contemplated by
            the Father, by The Son and The Sacred Spirit, and God's Glory
            covered me. <br />
            When The little God was put in my arms, the happiness and the joy of
            my Immaculate Heart covered the whole earth. <br />
            Glorify God!. <br />
            Amen. <b></b>
            ¡ Happy Birthday! <br />
            Blessed you are daughter of My Heart.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 1998</h6>
          <p>
            Peace and Jesus' Love is in your hearts.! <br />
            Take that Peace to your families, ask for Peace, conserve it in your
            hearts, take the Peace of the Lord where you go. <br />
            In the Sacred Sacrament, there is Peace, true Peace. <br />
            Adore Jesus! Adore him unceasingly. <br />
            Blessed you are my children! <br />
            Glorify God!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 1 1999</h6>
          <p>
            Praise be to the Savior! <br />
            Begin this year praising and blessing the "FATHER." <br />
            Praise him with your hearts, don't allow yourselves to make a
            mistake, clean your hearts, take out from them every wrong root and
            you will be able to say "OUR FATHER YOU WHO ARE HEAVEN." <br />
            Bless the FATHER in your hearts, let love grow in them and spread it
            around permanently over your siblings, as rain that falls from the
            Sky. <br />
            I bless you abundantly with my Maternal Blessing. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 11 1999</h6>
          <p>
            Blessed you are my children! <b></b>
            Today I bless you especially, and I bless every dispersed child
            around the world. Call the Father asking for his Mercy. Love your
            brothers; follow this Commandment that you have forgotten. <br />
            Happy those who love the Lord; because they will receive him and
            they will receive his Love; and this Love doesn't wither because it
            is true Love. <br />
            Blessed you are my children, Love is peace, peace inside your heart.
            Love heals sick people, strengthens the weak ones, and raises those
            who are down. <br />
            Pray so that they can love God a bit more every day. Practice this
            my sons! <b></b>
            I love you all. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 19 1999</h6>
          <p>
            Blessed you are my children! <br />
            In The Father, in the Son and in the Sacred Spirit. <br />
            Today I have come to encourage you and to guide you towards a life
            of constant prayer, sacrifice and work, imitating the virtues of my
            husbund Joseph. <br />
            Keep firm my sons, feed yourselves from God's Word to love him and
            to know him more. Let purity and humility shine in your hearts , as
            it shone in Joseph's heart. <br />
            You are living in a time of great interior desolation, because you
            look for the solutions to your problems among you and among material
            things. <br />
            Pray to the Holy Eucharistic Heart and you will receive all the
            answers. Jesus will be with you! Jesus is waiting for you, and he
            loves you. <br />
            I love you all. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 25 1999</h6>
          <p>
            Blessed you are My children. <br />
            Receive Peace in your hearts; do not let anything intervenes between
            you and The Lord, during this time of conversion and penance. <br />
            Work below the Light, as a true child of God, what is done in the
            darkness comes from the wicked one and in it will remain hidden. Oh
            my sons! how much pain produces me to see some people doing wrong
            and that they sink their souls in the darkness. <br />
            Remain below the Light! <br />
            Jesus is the Light; he who walks with Him, remains in the Light, and
            the darkness clears up with Light. <br />
            Convert yourselves soon, don't sin! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 4 1999</h6>
          <p>
            Glorify God! <br />
            Blessed you are my children! <br />
            Children of Church. <br />
            Be good servants, my sons! <br />
            Bring peace with you! <br />
            Be true Christian together with Jesus' Sacred Heart! <br />
            Be testimonies of union, peace and Love in the world! <br />
            Receive my sons all the happiness and the Love from my Immaculate
            Heart. <br />
            Glorify God! Glory!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 13 1999</h6>
          <p>
            Today I had a vision of the Lord and the Holy Virgin, I saw him with
            a gray tunic and the Holy Virgin with a black dress and veil. <br />
            Then I saw the Saint Church San Peter's Basilica and many Priests
            dressed in white surrounding her. <br /> I experienced the greatness
            of Church and Jesus Christs power over Her, in company of her Mother
            the Virgin Mary. I felt Satan's power trying to destroy her using
            all possible means; he, fought the Priests especially. Then I
            experienced an incredible joy when I looked at the multitude of
            Priests dressed in white praising God.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 1º 1999</h6>
          <p>
            My children sow Love among you, be instruments of God's Love. I am
            asking you to do so! <br />
            Jesus should REIGN among you, Resist the temptations of the wicked
            one be strong in prayer. <br /> Don't allow bad habits and the
            pleasures of the world to drag you. Open your hearts to God. Do as
            God's law commands. <br />
            Record them in your heart. And don't be afraid. <br />
            I bless you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 8 1999</h6>
          <p>
            My children: My Heart suffers because I see that many children walk
            lost; on the wrong road. I invite you to pray for these children, to
            pray with more involvement and fervor, to attract them to my
            "Immaculate Heart." <br />
            I bless you all. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 23 1999</h6>
          <p>
            (Pentecost Solemnity) <br />
            Sons, my message today is for you to love each other. <br /> The
            Sacred Spirit will pour itself abundantly over the whole earth and
            over all the dispersed children in the world. <br />
            If you love yourselves as your Father from the Sky commands you, the
            wrong will stop; it won't have room in your hearts, since you are
            free children of God. <br />
            Dive deeply into Jesus's Eucharistic Heart and receive his Divine
            Mercy. Allow hope to shine in your hearts because Your Father from
            Heaven loves you all with infinite love: I bless you on behalf of
            the Father, the Son and the Sacred Spirit's name. Amen. Hallelujah.
            Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 6 1999</h6>
          <p>
            (Solemnity of Christ's Body) <br />
            Look at Jesus, Jesus is alive and present among you. <br />
            Adore him! Adore him! in the Sacred Sacrament. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 11 1999</h6>
          <p>
            (Solemnity of Jesus' Sacred Heart) <br />
            My dear sons <br />
            Adore Jesus!! <br />
            Adore his Holy present Heart in the Sacred Sacrament, Adore your
            Creator. Kneel down in front of Him. My sons come to Jesus's
            Eucharistic Heart confidently. <br />
            You will be listened to. <br />
            You will Be filled with peace. <br />
            You will bring peace and happiness. <br />
            You will be blessed. <br />
            Trust in his Holy presence and you will be filled with his Love.{" "}
            <br />
            Blessed and Adored is God who remains with you. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>4 of Julio 1999</h6>
          <p>
            My blessed children: <br />
            Purify yourselves soon don't allow so many days go by. Remember your
            Sacred Mother who protects you, and clean your souls soon. Be
            obedient and constant in your prayer. <br />
            Nobody will die if you come closer to God confidently. <br />
            Be like children. <br />I bless you. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>9 of Julio 1999</h6>
          <p>
            Today I saw the Holy Virgin with the moon under her feet. <br />
            She said: <br />
            Sons: Love my Divine Son Jesus a bit more every day. It is necessary
            to prepare your Hearts to love Jesus more. It is necessary to pray
            every day, wanting to love Jesus more. Grow in prayer looking at
            your Savior Jesus. <br />
            Look at Jesus! Look at him and love him! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>16 of Julio 1999</h6>
          <p>
            My sons: I have come to join all my children during this time of
            special graces that my Divine Son Jesus grants you, to look for
            those who walk lost and without direction. Sons, in such dark
            moments humanity suffers, in a way that has never been seen. And the
            darkness inside the hearts has reached such a blackness and hardness
            that they are unrecognizable. <br />
            But my Son's infinite love allows me to look for you. <b></b>
            Work! my children Work!, for God's Glory. <br />
            Preach my messages without fear. <br />
            If you understood this big favor Heaven is asking you, you would
            become living torches. Love the Church! Join it and you will join
            Jesus. <br />
            Listen to my Words, and do not be surprised, be like children to
            understand. <br />
            Praise be to Jesus's Holy Eucharistic Heart. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15 1999</h6>
          <p>
            "Sacred Mary's Assumption" <br />
            My children you are saint!, receive my Love today. Pray today with
            confidence; I will intercede for you before my Divine Son Jesus.{" "}
            <br />
            Some children are heart-stricken and lonely. <br />
            Trust Me my sons!, Trust in me!. don't waste these Graces that YOUR
            FATHER FROM HEAVEN is giving you. Time goes by, I am WAITING for
            YOU, COME TO MY IMMACULATE HEART. <b></b>
            Look for shelter in him. I am looking at you, I am assisting you, I
            am waiting for you. <br />
            Glorify God! Bless him!. <br />
            Turn to God!. I love You all. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 of September of 1999</h6>
          <p>
            Praise be to The Sacred Trinity for all the eternity!. <br />
            My sons: I am God's love. I am your Immaculate Mother and I love you
            with immense love. Open your hearts to the Mother to understand the
            pure Love of my Heart. <br />
            Have the expressions of a boy and you won't hurt the Lord. <br />
            Be small and simple in your work. <br />
            I have those who have simple hearts in my hands and they have the
            Mother. Do you understand this my dear children? <br />
            Let all the hearts be mine! <br />
            It depends on you. I am offering my pure Heart. <br />
            Glorify God! <br />
            Praise be to the Lord! <br />
            I am Yours, come to Me! <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 September of 1999</h6>
          <p>
            I send you a great Blessing my little dear children; because you
            have responded to the Mother's call; and God's work grows in your
            town. <br />
            Thank you! You are Saint! <br />
            You are Protected by me! <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 14 1999</h6>
          <p>
            My sons: <br />
            Adore the Holy Cross with your heart! <br />
            Imitate Jesus; imitate him, loving The Cross, loading it with love,
            and pain will turn into happiness. Imitate Jesus, thank your FATHER
            FROM HEAVEN who sends him to you, and you will receive strengh to
            carry it. <br />
            Simple and pure souls, preach, preach with your example. <br />
            Love JESUSCHRIST; look at him without fear on The Cross. Come closer
            to The Cross with humility. Next to my Divine Son's Cross I turned
            into your Mom. Do you understand this great happiness?. Parise be to
            Jesus Christ! <br />
            Adored is his Holy Eucharistic Heart: I bless you at the Almighty
            God's Cross feet. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 15 1999</h6>
          <p>
            Jesus says: "I am Infinite Mercy, souls pass by my Mercy, before
            undertaking my trial." I see the Virgin and she tells me: <br />
            Children honour Jesus Christ. Honour him every day. <br />
            Meet him in the Sacred Sacrament. <br />
            Melt your hearts with the Divine Heart; He is the bread. Love his
            Holy Eucharistic Heart. <br />
            You are Saint! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 25 1999</h6>
          <p>
            Dear sons <br />
            I am very happy among you! <br />
            Glorify God! <br />
            I want to be worshipped, loved and obeyed, that is all I am asking
            you. To obey the Mother is to obey the Son. Because The Son sends
            The Mother, to gather the dispersed flock. <br />
            The flock will be congregated and blessed; The Mother will take a
            place next to the Son and The Son will be adored. <br />
            Endless will be the visit of my children. <br />
            Hallelujah, Glorify God, Hallelujah!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 13 1999</h6>
          <p>
            The message I bring you today is that you should love each other
            with generous love, without requesting anything in exchange. <br />
            READ, THE SACRED GOSPEL and you will remain in The Love. <br />
            You will receive God's love and you will be taught.. <br />
            In many places God's love is absent, and you get lost in vain.{" "}
            <b></b>
            The enemy is near you to lose deviate you, guiding you towards hate
            and envy so present nowadays. I tell you my children, love my
            Immaculate Heart, and don't allow yourselves to be deceived by the
            demon, be strong Christians, bring your hearts to God, give love,
            preach love, live in Jesus Christ's love. <br />
            Me your Mother from Heaven has come to you, to exhort you towards a
            radical change in your lives;
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8 1999</h6>
          <p>
            Dear sons: <br />
            I have come to you to bring Light amid deep darkness, even so my
            small children don't worry. I, your Immaculate Mother, invite you to
            meditate deeply with your heart to discern this time of Great Mercy
            that retains Divine Justice, which comes to you by means of my Pure,
            Sacred Heart. <br />
            Be careful not to fall in the nets of the prince of the world.
            Power, arrogance, wealth, recognize the infernal snake that will
            drag you to your soul death. <br />
            "Give yourselves away to God" without reservations. <br />
            Blessed you are my children <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 14 1999</h6>
          <p>
            Listen to God's Word and bless it. <br />
            During this time of advent prepare yourselves to receive Divine
            Little Jesus. Live with hope in your lives with pure heart. Be Sober
            !. <br />
            Blessed you are my children. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 1999</h6>
          <p>
            Let Peace be with you and let it go from this place to every place
            in the world. Be sober and moderated in your lives, every kind of
            materialism darkens the soul, perturbs your freedom, tiing them to
            bad habits and sins. Meditate on this my children and you will be
            free and willing only to adore God. Don't stop yourselves my
            children in mundane things; Love God above everything! I love you
            all. Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 26 1999</h6>
          <p>
            I see the Sacred Virgin with the Little God in her arms and Saint
            Joseph. Little Jesus is asleep in her arms and the Boy's beauty is
            incredible. Saint Joseph, who has dark eyes and hair and white skin,
            has a light violet tunic, and his beauty is superior to that of the
            angels I have seen. <br />
            The Mother says: <br />
            Be strong witness of your Faith, lean on God's Holy Word. "Adore the
            Sacred Sacrament" and you will be strong and you will be prepared.{" "}
            <br />
            During this time of great Mercy, satan is furious trying to destroy
            your faith, taking you on the way of atheistic materialism with a
            mask of humanism, he corrupts you and he takes you away from God's
            love. <br />
            My children, pray to be illuminated by the Sacred Spirit. <br />
            Glorify God! I bless you all.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 6 2000</h6>
          <p>
            Blessed you are my children: My Immaculate Heart will win. During
            this new time that begins Glories and commendations to God! Saint is
            the Lord! Blessed is his Saint name! <br />
            Saint! Saint! Saint! <br />
            Ask for your needs and you will be given, knock at the door and it
            will be opened. Invoke God and He will work marvels. <br />
            Amen. Hallelujah. Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 2 2000</h6>
          <p>
            Serve the Lord with humility and happiness, move away from the
            sadness; let the tribulations help you to love Jesus more. Love
            Jesus more and more and you will find the Light. How lonely you are
            my children when you lack of Jesus' Love. <br />
            I bless you all. <br />
            Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 11 2000</h6>
          <p>
            Praise be to Jesus Christ! <br />
            Sons, my Heart of Mother is attentive to your supplications. I
            listen to you all. Open your eyes and your ears to the Light of
            Truth. Grow in Love to Jesus; trust in his infinite Mercy. <br />
            If dawn breaks every day for you it is due to Jesus's Eucharistic
            Heart's Infinite Love. Be happy my children!, bless and adore the
            Lord present in the Sacred Sacrament. <br />
            Preach my messages, and many will be healed, and they will return to
            God I will be with you, I will be your strengh. <br />I Love you and
            I bless you with my Immaculate Heart. Thank you my children.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 8 2000</h6>
          <p>
            Sons: I have come from Heaven to instruct your hearts in true Love,
            who is Jesus. <br />
            Begin this time of Lent praying asking for The Sacred Spirit. You
            should want to be illuminated by Him. If you pray with perseverance
            and fidelity, He will come to your hearts and He will truly convert
            you. <br />
            My children fast; offer the fast to Jesus, feel that you are doing
            so for him. You should want to fast for Jesus. <br />
            Pray with your heart; come closer to the church and share with your
            siblings The Holy Mass is a meeting of Peace and Love. <br />
            He who is mercyful loves God. <br />
            He who looks just for himself will be alone and God is not in him.{" "}
            <br />
            Convert yourselves and love your brothers! <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 25 2000</h6>
          <p>
            Praise be to the Holy Trinity! Blessed you are my children during
            this special day. Let peace and love reign in your homes! <br />
            Open your hearts to the immense Love of God; let Jesus be the most
            important thing in your lives and let him take you to an interior
            change that transforms your lives. <br />
            During this Lent remain in prayer to be stronger. <br />
            Be happy and rejoice you who listen to and preach my messages,
            because I will cover you with my Immaculate Heart. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 23 2000</h6>
          <p>
            (Easter - Resurrection) <br />
            Praise be to Jesus Christ! <br />
            My sons thank God today. Let Jesus' peace feed your hearts. <br />
            Be happy my sons! at this Easter! Be Saints! <br />
            Pray in order to be able to adore God. <br />
            Pray in order to be able to give your lives away completely to God.{" "}
            <br />
            Be happy especially those who recognize this time of grace and don't
            sadden it. <br />
            Thank God for this Sacred year of immense graces the divine mercy is
            giving you. <br />
            Ask especially for those who have hardened their hearts and remain
            in hate and envy saddening my Heart. <br />
            Pray and meditate on this message deeply. <br />
            Open your hearts to life, to God's true life. <br />
            I bless you thoroughly. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 30 2000</h6>
          <p>
            Today The Lord and the Holy Virgin came (together). <br />
            Jesus says: <br />I give you my Peace! <b></b>
            Take my peace, be fair and you will be taking my peace. <br />
            If my peace is with you, you will be fair and you will love each
            other. The Mother says: <br />
            Sons: Pray especially for having Love in your hearts. Pray
            especially so that love grows in your community. You are not aware
            of my orders. <br />
            I am your Mother, if you listen to me you will know this Mother and
            you will listen to the Son. If you pray and you listen to my
            messages you will know me and I will be able to help you grow in the
            love towards Jesus and your siblings. <br />
            Begin to pray with your heart to receive peace during this time of
            great mercy. I bless you thoroughly <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 08 2000</h6>
          <p>
            My Heart is overflowing with happiness for you my children, because
            you are called to the love of Jesus's divine Eucharistic Heart.{" "}
            <br />
            My sons enter into my Immaculate Heart, and I will teach you the
            love, LOVE of JESUS' Divine Heart. Praise the Lord, my children,
            praise him with burning heart. Smile and praise with strengh Jesus's
            Holy Eucharistic Heart. <br />
            Let these commendations move and shake the world I Cheer up my
            children! <br />
            Blessed you are. <br />
            Blessed you are. <br />
            Hallelujah. Hallelujah. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 13 2000</h6>
          <p>
            Sons Pray for the Peace! Pray so that hate and disagreements don't
            darken your hearts. Be humble! Receive my messages with humility;
            open your hearts to my Love Be Humble! and please Mary's Immaculate
            Heart, she comes to you to avoid your sufferings. <br />
            Consecrate you to "Mary's Immaculate Heart and to Jesus's Holy
            Eucharistic Heart"; consecrate my sons and preach these
            consecrations, if you do so my Immaculate Heart will triumph and you
            will have peace. <br />
            Today I have come to you to ask for your prayer and sacrifices, so
            that the world responds to this call for conversion, men should
            return to our Unique God, Endless Good. During this time of Grace
            and Mercy, satan tempts you; darkening your souls with sins,
            weakening your strengh, taking them away from the infinite Love of
            God. Pray with faith and hope my sons and begin to live my Messages.{" "}
            <br />
            Today May 13th 2000 the whole world is blessed by heaven's sake,
            pouring immense graces, which are falling from HEAVEN like
            waterfalls over the souls, honouring Mary's Pure Heart. <br />
            Thank you for listening to me, I bless you especially. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 11 2000</h6>
          <p>
            (Solemnity of Pentecost) <br />
            Dear sons of my Immaculate Heart. Join me in prayer completely. Be
            Humble and patient lambs; imitating the SACRED IMMACULATE LAMB,
            God's Unique Son. <br />
            Pray with great fervor, ask for God's presence in your life with
            strengh; allow yourself to be flooded by the Sacred Spirit's Love.{" "}
            <br />I love you and I bless you all. <b></b>
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 25 2000</h6>
          <p>
            (Corpus Solemnity) <br />
            Today I have seen Jesus and his Sacred Mother. <br />
            Jesus' Body shone with extraordinary radiance of golden rays that
            wrapped him totally (I say rays that wrapped because I noticed the
            sheaves of lights going out of his Body). <br />
            Jesus dressed in an immaculate tunic has in his chest his bleeding
            Heart shining with special lights and his two Hands taking it; as
            Priests do when they take the Sacred Communion. The Sacred Virgin
            remained down on bended knees in front of Jesus in silence and in
            attitude of adoration. God´s Mother was also wrapped in Jesus'
            golden Light. <br />
            Jesus said looking at me with immense Love and with sweet voice.{" "}
            <br />
            I will always be with you! Come to Me, trust me. <br />
            Eat and drink from the inexhaustible source of my Love come all to
            Me; prepare your hearts and my Spirit will shine in you. <br />
            Come to me all of you who have been blessed by my father..
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 29 2000</h6>
          <p>
            (Solemnity of Saint Peter and Saint Pablo) <br />
            Sons, you are being hit in many ways by the wicked enemy; the enemy
            tries to lose you, inciting you against God and guiding you towards
            spiritual laziness and this way to take you away from the one on the
            way to Salvation. <br />
            In these times, when you have to live, a rain of graces is falling
            over you, don't let this moment pass by. During these times there is
            a spiritual combat between Heaven and the wicked powers of the
            earth. Don't move away from Church. Pray the Sacred Rosary every
            day, with this prayer the enemies will be conquered. <br />
            I love you all with immense love. I bless you. <br />
            Amen. Hallelujah. Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 30 2000</h6>
          <p>
            (Solemnity of Jesus' Sacred Heart) <br />
            Many children walk afflicted outside Christ's Light. My children are
            brave witness of the Gospel nowadays. Don't keep silent!. Preach my
            messages with fervor, transmit them completely, it is very important
            you do so, don't be afraid; Jesus' Divine Heart will keep you, Jesus
            is God and God is with you, Consecrate yourselves to Jesus's Holy
            Eucharistic Heart and Mary's Immaculate Heart. <br />
            Be Constant. <br />
            Praise be to Jesus's Eucharistic Heart in all the Tabernacles of the
            world! <br />
            I love you and I bless you thoroughly. <br />
            Amen Hallelujah, Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>1 July 2000</h6>
          <p>
            Sons come to my Immaculate Heart dive inside my maternal Heart, to
            take you to Jesus' Divine Heart. Today I want to bless my small
            children especially those who suffer poverty, those who are sick and
            excluded, my aching children, those who ask for my help as God's
            Mother; I tell them; Come to Me tiny children, come and stay below
            my Mantel; this is time of great Mercy given by heaven's sake . Go
            with confidence and I will help you. <br />
            I bless this earth and all the children that love me and honour me.{" "}
            <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>19 July 2000</h6>
          <p>
            (Italy Bologna, Sanctuary of San Lucas) <br />
            Blessed you are! <br />
            Thank you for answering my call!, my Immaculate Heart is happy for
            you and for your town; because you have opened your hearts to my
            Love, I bless you and I will bless you. Don't be afraid, there will
            be many difficulties during the construction of the Sanctuary, but
            everything will be completed according to my desire for my Divine
            Son Jesus's Glory and Commendation.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25 July 2000</h6>
          <p>
            (Italy San Giovanni Rotondo, Church Santa Mary of the Grace) The
            Sacred Mother said: <br />
            María, daughter of my Heart, I wish all the doubts present in your
            heart were dispelled. Your heart remains and will remain inside my
            Immaculate Heart and all you do is guided by Me. <br />
            Mother from this place I want you to guide me: How do you want your
            messages to be distributed? Answer: <br />
            I am very happy with you because you have opened your heart, you
            have obeyed my commands with fidelity, I wish you would multiply the
            prayer groups and today I will grant you a wish, soon you will see
            that lights like stars in the sky will begin to shine and they will
            extend all over the whole world to Adore and to honour Jesus's Holy
            Eucharistic Heart. <br />
            Mother how do you want us to pray? <br />
            Pray with pure heart, pray as the small ones, as my small children.
            My small children pray unceasingly, because yourr lives are locked
            in Jesus' Heart, your lives are a permanent image of Jesus and this
            is a permanent prayer to the Father, who finds joy in you.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>27 July 2000</h6>
          <p>
            (Medjugorje, during the Sacred Rosary's prayer in the Temple)
            Receive Peace and Mercy my dear children, I love you and I bless you
            all. I will apppear to the world, when the day begins, at midday,
            when the day finishes and in it Salta when dawn breaks, because it
            is time of Resurrection.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 July 2000</h6>
          <p>
            (Yugoeslavia - Medjugorje) <br />
            28 July after Holy Communion The Sacred Virgin said: <br />
            Dear young people, I am among you, I want you to have pure hearts.{" "}
            <b></b>
            Today while we prayed the Sacred Rosary the Holy Virgin appeared.The
            Virgin was in Church surrounded by small clouds which reminded me of
            lamb skins. Then above Her, The Sacred Spirit that shone with lights
            and rays of extraordinary radiance which fell over the people.{" "}
            <br />
            At the moment of the Sacred Communion, the Sacred Family of Nazareth
            in the manger, was present over the Tabernacle.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>28 July 2000</h6>
          <p>
            (Medjugorje, in the hill where the Blue Cross is) <br />
            The Holy Virgin went down from Heaven at 22 hs. with intense
            lightnings, She dressed a gray and white tunic, of impressive
            beauty. Dew Heaven and perfume of roses accompanied her, and she
            said: I am very happy among you, I Bless you and send and Jesus
            Christ's Peace. <br />
            Protect yourself from satan taking Saint Benito's Cruz. <br />
            Today I have come especially to you because I want to take all your
            needs to Heaven. <br />
            She extended her Hand towards my hand and I lifted mine until
            joining it. Then she left.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 5 2000</h6>
          <p>
            Today when seeing the Mother from Heaven I meant to tell her Happy
            day Mom!, but instead of that I said: <br />
            "Hail Mary full of grace, the Lord is with thee, blessed are thou
            among women, and blessed is the fruit of thy womb Jesus. Holy Mary,
            mother of God, pray for us sinners, now and at the hour of our
            death. Amen." <br />
            Mother was radiant in beauty and happiness and she smiled very, very
            happily, I told her: I love you with all my heart. She said: <br />
            "Pray, pray, pray the Sacred Rosary, you please me with this prayer,
            it is time to pray and to fast; make sacrifices for those who sin. I
            Bless you all today with the Light of my Immaculate Heart. I love
            you intensely <br />
            Thank you, thank you! <br />
            Praise be to Jesus Christ!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15 2000</h6>
          <p>
            (Virgin Mary's Assumption) <br />
            Praise be to the Lord! <br />
            Blessed you are my children; my Immaculate Heart is overflowing with
            Love and happiness, because you have understood my Messages. <br />
            You are on the way of Love, go; Preach my messages without stopping.{" "}
            <br />
            Blessed you are, I Love you with my Immaculate Heart <b></b>
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>8 of September of 2000</h6>
          <p>
            (Córdoba) <b></b>
            My children: during these times of many difficulties, you should
            devote time to praying. <br />
            Pray in group, in family and alone, the most important thing is that
            you pray in a permanent way; every day, until getting the favor from
            the Sky. This my children is a very pleasant gift for Me and I take
            it to Heaven. <br />
            I love you and I bless you <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 September of 2000</h6>
          <p>
            Peace my sons! Peace among you! Small flock of the Lord you walk
            according to my Son's Divine Will Jesus. Today I have come to ask
            for your hearts, give your hearts to my Son, Jesus's loving Heart.{" "}
            <br /> Come closer to Jesus' Divine Heart who is present in the
            Sacrament. Tell him you want to follow him; be the Town of God. Tell
            Jesus's Holy Eucharistica Heart you want to belong completely to
            him. Jesus looks at you full of love. <br />
            Don't keep my words, live them! with love. Jesus is waiting for you!{" "}
            <br />I bless you and I love you intensely let Jesus' Peace remain
            with you.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>13 September of 2000</h6>
          <p>
            God wants us to: <br />
            Love him with all our heart. <br />
            To serve him with all our being <br />
            To love his Divine Will, and to wait everything from him. <br />
            You have my Messages, today I am speaking to you to educate you and
            to take you to Jesus.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>14 September of 2000</h6>
          <p>
            Sons, be sincere in your conversion. I love you and I invite you to
            live a great Miracle in your lives. <br />
            The Miracle of really adoring Jesus. You can adore Jesus if you let
            Him live among you. <br />
            Regret your sins, purify your conscience to love Jesus and abandon
            yourselves to him completely. <br />
            Praise be to Jesus Christ! Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>15 September of 2000</h6>
          <p>
            Jesus says: <br />
            "Come to Me", small souls who trust in My Mercy. <br />
            Don't be afraid of my Love, I give myself away totally to those who
            are humble and simple. <br />
            Those who do not follow commands won't find me. I am The Good
            Shepherd, I am guiding you, trust my Mother. I have given my Mother
            the power of the Love. He who obeys my Mother will know the Father,
            the Son and Holy Spirit's love. Be blessed , pacify the earth.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>25 September of 2000</h6>
          <p>
            Pray, my sons pray. Without prayer you cannot do good things because
            the prayer makes your work to be carried out by The Spirit of God.{" "}
            <br />
            I want to teach you to carry out your work with love, because
            loveless work is dead work. Jesus is Love! and every Love comes from
            God. <br />
            - If you pray you will begin to love. <br />
            - You will feel love growing in your hearts. <br />
            I bless you all with the light of My Immaculate Heart. <br />
            Amen Hallelujah, Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 7 2000</h6>
          <p>
            Remain in Love! <br />
            My sons, I bless you abundantly today, and I tell you all, remain in
            Love, don't choose another road besides remaining in Love. <br />
            Straighten your will, be docile in the prayer to the Sacred Spirit,
            what your lips repeat , should be repeated by your heart. <br />
            Convert my children to the Love of God! <br />
            Pray with your heart Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 12 2000</h6>
          <p>
            Dear children: " Blessed you are in the Father,the Son and the
            Sacred Spirit's love!" <br />
            Prepare your hearts to remain in The Love of God. <br />
            My children understand the time you are living; satan is trying to
            take you away from this Love, the one seeks to be the owner of your
            hearts, and it inspires you against the Divine Will. He tries to
            feed them with bad examples. <br />
            Pray with the Commandments. <br />
            Feed with the Sacred Sacrament. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 13 2000</h6>
          <p>
            I see the Holy Virgin dressed in white, she is on a big cloud, from
            her Heart comes out an immense Light that scatters, towards every
            side, covering the world and even beyond where I do not understand.
            This Light covers everything. <br />
            The Mother says: <br />
            "Praise be to Jesus Christ The Immaculate Lamb" <br />
            This is the Light that shines after the Victory of My Immaculate
            Heart, it is the Sacred Rosary's victory. <br />
            This Light will illuminate the darkness. <br />
            It is the hour of great hope. <br />
            My sons go on praying; go on working for God . For God's Kingdom,
            which must come. If they could understand what God's Kindom is, they
            would die full of joy. <br />
            Continue, don't stop! <br />
            I love you all Thank you! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 1 2000</h6>
          <p>
            Thank you my sons for being docile to my petition! <br />
            Continue praying and fasting for my intentions. God will do big
            things if you persevere doing so. Open your hearts sons and you will
            understand the Mom's task, she wants to take you towards Sanctity!
            Open up your hearts and the hardened hearts will move in this way,
            the sad ones will be happy, those who are heart-stricken will be
            consoled, ill people will be healed, children will be protected from
            the mother's breast. <br />
            I want all of you to return to my maternal Heart to take you to the
            Father, the Son and the Sacred Spirit's love. <br />
            Do sacrifices my sons for this intention, do not be afraid. <br />
            I love you all <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> November 7 2000</h6>
          <p>
            Praised be to Jesus Christ <b></b>
            Trust Me! <br />
            I am your Immaculate Mother, listen to my voice and don't be afraid{" "}
            <br />
            I am the whole humanity's Mother. Blessed will be those children who
            listen to me. Adore Christ, present in the Sacred Sacrament, Only
            Mediator between God and Men. <br />
            Glorify God! <br />
            Saint you are.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8 2000</h6>
          <p>
            My sons <br />
            "Convert yourselves totally to God" consecrate your hearts to God.{" "}
            <br />
            You should want to convert and to consecrate your lives to God.{" "}
            <br />
            During this new dawn you should want to consecrate to the Father ,
            the Son, and the docile Sacred Spirit's love. Be docile to this
            consecration!. <br />
            Open your hearts!. <br />
            Pray and say: <br />
            "Virgin Mary I accept to be consecrated by You to the Sacred
            Trinity's love." Meditate in silence to understand this with your
            heart. <br />
            "Me, the Mother will sow, you will pick up" Glorify God! Saint you
            are, I love you all.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 2000</h6>
          <p>
            Today the Mother of Heaven was specially beautiful, many small
            Angels accompanied her, they were joyful and the Light that they
            irradiated was so strong that could turn the night into day. It is a
            light full of Love. <br />
            After making the sign of the Cross the Mother says: <br />
            María daughter: I want to be with all my small children this
            Christmas, to bless them with my Immaculate Heart. <br />
            The Night of the Little God's birth the doors of Heaven opened up
            for the whole humanity. <br />
            In the deep silence of that night, we saw with Joseph, my husband:
            Heaven in the earth, this is a deep mystery of God's love. <br />
            The Little God, had his first cradle in my Heart, I rocked and
            adored his small Heart next to mine and my husband Joseph did so.
            Little daughter, the doors of Heaven will continue open for everyone
            of you, until the end of times. <br />
            I bless you and I bless especially everybody in the Father, the Son
            and the Sacred Spirit's name. Amen Hallelujah. Amen Hallelujah.{" "}
            <br />
            Happy Birthday daughter of my Heart!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 6 2001</h6>
          <p>
            My sons, I bless you today. I want to give you a piece of advise,
            live consecrated to God's Love. Pouring this love among those who
            are poor and have been forgotten. <br />
            Be instruments of God's Love, be perfect doing so! <br />
            Live the charity with pure heart. <br />
            Be generous from the bottom your hearts. <br />
            My Maternal Heart finds happiness in these hearts. I love you all.{" "}
            <b></b>
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 11 2001</h6>
          <p>
            Blessed you are! Peace and Love are poured over you. <br />
            During this time of hope I want to protect your homes; and I invite
            you to do that in a simple way.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 19 2001</h6>
          <p>
            (Solemnity of Saint Joseph) <br />
            Praise be to Jesus Christ! <br />
            Don't be afraid my children, trust in the Lord every day, be
            perseverant in your prayer!. <br />
            I am very happy with you because God's plans are being completed.
            Blessed are those who walk next to Me, because they take my hand and
            they won't fall. <br />
            Open your hearts! and I will grant you a grace today, in honor of my
            husband Joseph. Be happy, be happy, be happy! <br />
            I am the Mother, I am your Mother! <br />
            Go on, don't stop! <br />
            I bless you all. <br />
            Amen, Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 12 2001</h6>
          <p>
            (Saint Thursday) <br />
            When this new dawn breaks my sons, the terrible enemy of God, tries
            to thwart the true Faith, sowing distrust among your hearts, filling
            them with dark thoughts, weakening the consciences. <br />
            The 7 capital sins reign in the world, governing the souls, until
            the extermination, men with perverse intentions, corrupt a countless
            number of souls, from morning until night and during the night.{" "}
            <br />
            My sons be fair and work with true love for God's Kingdom without
            stopping. <br />
            Every time is God's time. <br />
            Adore and serve God. <br />
            Glorify and adore God, <br />
            Adore Jesus Christ who is present in the Sacred Sacrament. <br />
            Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6> April 15 2001</h6>
          <p>
            (Sunday of Resurrection) <br />
            I see the Sacred Virgin down on bending knees in front of a great
            Light. She is irradiated by this intense Light. In the middle of
            this great Light, in front of Her, is Jesus, his Body is like a
            source of light, which comes from his Sacred Wounds specially.{" "}
            <br />
            Jesus with a lot of Love and Happiness looks at its Sacred Mother.{" "}
            <br />
            Christ's head and face are of an impressive beauty. <br />
            Jesus opens his chest and showed his Mother his impressive wounded
            Heart and he gives it to the Holy Virgin. She extends her hands
            showing that she wants to receive it, and raises her face towards
            Him. I see the Holy Virgin, transfigured Mother and Son remain
            together, united. After this I see the Mother full of happiness and
            she says: <br />
            - Glorify God, hallelujah, hallelujah.! <br />
            - Bless is the Lord. every town should bless God! <br />
            - Praise be to the Lord, every town should praise him! <br />
            - Adore the Lord, everyone should adore the King of Glory! <br />
            - Glorify Father, glorify the Son, glorify the Sacred Spirit. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 08 2001</h6>
          <p>
            (Our Lady of Luján, Patron of Argentina) <b></b>
            Blessed you are my sons! <br />
            Adore Redeeming Christ! <br />
            Be small like children who receive the food from their mother. Feed
            yourselves with the source of Mercy that is Jesus' Divine Heart,
            present in THE SACRED SACRAMENT. Love, love Jesus! present in the
            SACRED SACRAMENT. My Divine Son is waiting for you to fill you with
            graces, to all of them who ask for them. <br />
            If you have difficulties and sufferings, come back to Jesus and you
            will be filled with his Love, the poorest ones will receive more and
            you will be happier. <br />
            Glorify God! <br />
            I love you and I bless you all and on such a special day in
            Argentina. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 13 2001</h6>
          <p>
            Blessed you are my sons! <br />
            I want to take you to God's Love, to his Divine Mercy. <br />
            No wrong will prevail on you if you trust in his Love. <br />
            During this time of big tribulations, many of you feel abandoned and
            empty; full of bitterness, reproaching, reproaching. They inflate
            their hearts with hate and fears. What a waste of time! My sons, God
            is with you. God's Love is very near you. Pray to be able to feel
            God's Love in your lives. <br />
            Pray a bit more every day. Blessed are those who pray! <br />
            Amen Hallelujah. Amen Hallelujah. <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 27 2001</h6>
          <p>
            (Solemnity of the Ascension) <br />
            My sons: <br />
            Let Jesus live in you! <br />
            Be generous while offering yourselves, put selfishness that enslaves
            you away. <br />
            Be compassionate with the others. <br />
            Amen with the heart! <br />
            Be small and you will be big in Heaven. <br />
            I love you all <br />
            Love Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 3 2001</h6>
          <p>
            (Pentecost Day) <br />
            My sons: <br />
            Praise be to God! What a wonderful time this is! God's Love is
            poured over the whole world without measure. <br />
            My sons receive God's Love opening your heart. <br />
            You should want to forgive, to give, to be instruments of God's
            Love. <br />
            Be faithful witness of the Gospel,Pray to receive this with your
            heart! Glorify God! <br />
            Be blessed all of you who live in the whole world! <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 10 2001</h6>
          <p>
            SACRED TRINITY's Celebration <br />
            My dear sons: <br />
            I have come to bring The true Peace, stay away from the false peace
            offered by the world. Pray for the Grace of the Love; pray in
            silence in front of JESUS, present in the SACRED SACRAMENT, to
            receive this in your heart. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 17 2001</h6>
          <p>
            (Solemnity of Corpus) <br />
            Pray my sons, pray...! <br />
            Intensify your prayer, I thank you for answering my call; pray all
            of you with more sincerity. To pray in an unaware way is not to
            pray. <br />
            Open up your hearts during prayer and meditate the given messages.
            My Heart is happy for you but there are still too many who remain
            cold; indifferent to my Heart. Make small sacrifices for them,
            uniting them to the pain of my Heart, Me the Mother is suffering for
            them. <br />
            Go on fasting, preach this. This is time of harvest, don't put your
            arms down. My love will give you strengh. <br />
            I love you a bit more every day! <br />
            Blessed you are! <br />
            Praise be to Jesus's Holy Eucharistic Heart, present in the Sacred
            Sacrament. <br />
            Adored, adored, adored is my Divine Son <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>22 dc June 2001</h6>
          <p>
            (Sacred Heart) JESUS says: <br />
            Don't harden your hearts, put yourselves under my Mother's
            protection. <br />
            I am with you <br />
            I love you! <br />
            Trust in My Heart <br />
            The Mother says: Pray to Jesus' Sacred Heart, depend totally on his
            Love: <br />
            I thank you for accepting my Love. Be mine a bit more every day, in
            prayer and work, so that God's plans, those which have been prepared
            for you from this place towards the entire world, are completed.{" "}
            <br />
            I want to be worshipped and well-known in the whole world as "THE
            IMMACULATE MOTHER OF JESUS'S DIVINE EUCHARISTIC HEART"; so that he
            is adored and honoured, JESUS'S DIVINE EUCHARISTIC HEART, present in
            the Sacred Sacrament. <br />
            Blessed you are! <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 16 2001</h6>
          <p>
            Let peace and happiness reign in your hearts, on such a special day.{" "}
            <br />
            I bless you thoroughly and I attract you to my Immaculate Heart's
            silence. <br />I am supporting you, Go ahead! <b></b>
            I am Your Mother. <br />
            I love you all. <br />
            Amen Hallelujah. Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 5 2001</h6>
          <p>
            Praise be to Jesus Christ! <br />
            Blessed you are my sons! <br />
            I want to grant you today the Pure Heart's love. <br />
            Thank you for answering the call of my Heart. <br />I want you to go
            on praying and fasting for my intentions, be persistent! Fast and
            prayers are necessary in this work of Heart, pray to be able to
            fast, and fast to be persevering and you will be able to understand
            this inside your heart. Don't be afraid; go ahead, look for Heaven
            and don't be afraid. <b></b>I am happy for you, because you are
            receiving great spiritual benefits. <b></b>
            I promise I will fill your hearts with happiness. <br />
            I love you a bit more every day. Amen <br />
            Hallelujah, Hallelujah, Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15 2001</h6>
          <p>
            Blessed you are! <br />
            My children: I want that discover God's Love inside your hearts.{" "}
            <br />
            It is necessary to grow up to know him more. <br />
            You have been created by God and God is Love. <br />
            Open your soul, to let the light in; you will be liberated from all
            the wrongs and sins. Be docile in confession, thank for this grace.{" "}
            <br />
            Be happy next to my Immaculate Heart. <br />
            My Immaculate Heart is the powerful force that nobody can destroy. I
            love you a bit more every day. <br />
            Glorify God! <br />
            Amen. Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 22 2001</h6>
          <p>
            Be pure my sons; don't allow bad thoughts to leave a stain on your
            hearts. <br />
            Be aware especially of the things which are deceiving. <br />
            I want to teach you the road of Love and Peace; which is born in
            Jesus' Heart. Come back to Jesus! <br />
            Begin to adore the Sacred Sacrament. <br />
            I want to take you to Heaven. <br />
            I will remain here. <br />
            Thank you for opening your hearts! <br />I love you more every day.
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 8 2001</h6>
          <p>
            Blessed you are my sons! <br />
            I ask you to go on praying and to make it with more fervor and
            perseverance every day. Many hearts are still very hardened because
            they don't Believe. <br />
            Satan wants to destroy and to thwart God's work, which is for the
            whole world. Pray, Pray, Pray. Let the Sacred Rosary be always your
            company. <br />I love you more every day.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 13 2001</h6>
          <p>
            Let Peace be with you! <br />
            My sons: I want you to go on working for God's Kingdom, during this
            time of darkness. Don't stop! Go ahead and your prayer will go up to
            heaven and will illuminate the earth. My sons you are instruments of
            peace. <br />
            My Immaculate Heart suffers from the big errors, the terrible tests
            and the tribulations you have to face. <br />
            God's enemies work fast and hit with sanguinary furor; surprising
            everyone. <br />
            Be light my children! <br />
            Don't be surprised, I am showing you The Road. <br />
            Love and don't hate, Pray and don't condemn. <br />
            Sow peace everywhere. Stop the wrong with Good work. <br />
            I am your Mother and I love you more every day. <br />
            Blessed you are. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 15 2001</h6>
          <p>
            My children: Open your hearts to God. <br />
            Today you will consecrate yourselves to the Crucified Christ and his
            Mother. <br />
            After this, take the Cross to your home, and put it like the centre
            of your lives. Go on praying in front of The Cross; that it is
            Source of Life and the Spring from where Hope sprouts. Convert
            yourselves, to be illuminated by the Sacred Spirit. <br />
            Pray looking at The Cross, meditate on this my children! <br />
            The Cross is the Door Heaven, I am standing next to the door and I
            call you; for that reason I am with you. <br />
            I want to help you to find The Road. <br />
            Continue meditating my messages and living them with sincerity.{" "}
            <br />
            I bless you especially today. <br />
            I love you more every day. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 25 2001</h6>
          <p>
            My children: Go on working for God's Kingdom with perseverance,
            satan tries to tire you and to discourage you until you desist. Be
            as the good seed which falls in fertile earth; meditate on this!
            Pray for the love to Jesus' Divine Heart. <b></b>
            During these days sacrileges, insults and blasphemies have increased
            against God. <br />
            During this time of tribulation, you have not overturned toward
            prayers, neither to sacrifice, many souls remain in the darkness,
            mutilated, black of sins. Very few souls have returned to the Lord
            and the lukewarmness of your hearts produces sadness in Heaven.{" "}
            <br />
            Convert yourselves! from the deep of your heart, pray with your
            heart! not with your mind. Leave aside mundane things, parties and
            hobbies. <br />
            During these days you are suffering a martyrdom in your hearts to be
            purified my children, don't be afraid! those who are faithful to my
            Immaculate Heart, you will be guided inwardly and you will know how
            to behave, there won't be fear in your hearts. <br />
            Blessed you are! I love you more every day
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 01 2001</h6>
          <p>
            My sons: <br />
            Be simple and small like children to know God's Love. I love you
            more every day. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 07 2001</h6>
          <p>
            Today The Immaculate Mother, is dressed in white, she has a golden
            crown with precious stones over her Head, in her hands a rosary of
            pure gold. <br />
            The Mother says: <br />
            Pray my sons, pray for the peace in the World!!. <br />
            During these days terrible things happen in the World. You listen to
            great quantities of bad news; you don't receive peace. <br />
            You want peace, you want peace, and you complain because peace seems
            something impossible to reach. There is not peace in the world,
            neither in cities, there is not peace in the families, neither in
            people; because you have forgotten God who is the true Peace. <br />
            Pray my children to get Peace. <br />
            Every day look at Heaven where God lives, pray with your heart,
            receive God in your Heart and you will receive peace. <br />
            Live this peace inside each one of you and spread it around. <br />
            How beautiful God's peace is! coming out from hearts!. <br />
            Cheer up my children and pray, pray the Sacred Rosary. <br />
            I love you more every day. <br />
            The Mother showed me her Immaculate Heart that shone intensely and
            her love went into my heart and she said: <br />
            "This is my Pure and loving Heart that intercedes with supplications
            and tears to the Lord for those hearts which are hard and cold.{" "}
            <br />
            This is Mary's Immaculate Heart which satan will never be able to
            conquer." <br />
            Don't be afraid of my Heart my daughter, pray a lot, a lot and don't
            fear, trust Me" <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 13 2001</h6>
          <p>
            Dear children: <br />
            I ask you to renovate your lives. Adore God! above everything. It is
            not possible to know The Divine Love if you don't prepare your soul.{" "}
            <br />
            During these days I see sad hearts and heart-stricken faces. Cheer
            up my sons! The Lord's Mother is with you. <br />
            Pray to God with trust, pray a bit more every day, and live what you
            pray. Pray and say: <br />
            "My Lord, and my God come to my heart renovate my faith Open my
            heart to receive and to give Fill me with your love." <br />
            Saints you are. <br />
            I love you more every day <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 15 2001</h6>
          <p>
            Dear sons: <br />
            During these days The Lord is filling you with special graces,
            impossible of experiencing, without opening your hearts; without
            praying. <br />
            I want to help you to receive these Graces of God. <br />
            It is necessary that you have time for the prayer, Pray with your
            hearts To pray with your heart: is to want to love God above
            everything. <br />
            To pray with your heart: is meeting God and being alone with Him.{" "}
            <br />
            To pray with your heart: is to be aware of what we are doing, Praise
            God and his immense Love; don't stop in adversity. <br />
            Walk taking my Hand. <br />
            I love you more every day with intense love. <br />
            Blessed you are. <br />
            Amen. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 1º 2001</h6>
          <p>
            Go on praying with great fervor during these days, and mainly, make
            good confessions; allowing God's love to be in your hearts. <br />
            I want to fill them with peace and love so that you can love God and
            your siblings more. Give yourselves away totally to "Jesus's Holy
            Eucharistic Heart" and to "Mary's Immaculate Heart." Blessed you are
            my sons. <br />
            I love you more every day. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8 2001</h6>
          <p>
            My sons: <br />
            Blessed you are! Today is a special day! I bless you thoroughly for
            this step given in such generous way; your work shines in Heaven
            with beautiful radiance. <br />
            My small sons, I am very happy among you! <br />
            Myy Immaculate Heart wants you to go on serving God with Love.{" "}
            <br />
            God is Love. <br />
            Pray and trust me, and you will see the marvels of the Lord
            descending over you and over all the pilgrims of the world who
            arrive here with love and trust in God. Thank you! Thank you! Thank
            you! My sons. <br />
            I love you more every day with intense love. <br />
            Amen Hallelujah Amen Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 2001</h6>
          <p>
            Praise be to Jesus Christ! <br />
            My children: <br />
            Don't be afraid, put your hearts up at this Christmas, have peace
            and happiness in your hearts, good hearts should not be afraid.{" "}
            <br />
            Blessed you are, I love you more every day! <br />
            Amen Hallelujah Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 2001</h6>
          <p>
            María daughter: <br />
            At the moment of the little God's birth, the whole nature
            transformed itself. The Glorious splendor coming out from my body,
            was so intense that it transformed all the things surrounding us, it
            was radiant. <br />
            When The Little God was in my arms, his eyes opened up for the first
            time. Looking at me for the first time. I felt an immense joy inside
            all my being. And The infinite Love of God covered me completely.
            The Light was in the world and darkness was dispersed. <br />
            I dressed my Divine Son with a white cotton shirt and another
            identical made of wool; I placed a small strip above his body, and I
            wrapped it in diapers. <br />
            Finally I brought him near my chest covering him with kisses,
            stroked him and fed him. We stayed doing so for a long time. <br />
            How long had I waited for this moment! <br />
            Glorify God Hallelujah! <br />
            Blessed and adored is God! <br />
            Amen Hallelujah, Amen Hallelujah. <br />
            Blessed you are Mary, daughter of my Heart. <br />
            Happy Birthday!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 6 2.002</h6>
          <p>
            My Sons: Pray persistently to be able to complete Gods plans for
            you. The end of the prayer is the meeting with Christ, my Divine
            Son. Pray with great fervor and trust in me, because "God" is with
            you. The world is contaminated by serious mistakes guiding the whole
            humanity to live in the darkness; to ignore Gods Love. Come closer
            the Light of His infinite Love, present in The Sacred Sacrament.
            Thank continually Father God, this torrent of graces falling over
            you, and spreads over the world. Blessed you are, I love you more
            every day. Amen. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 2 2002</h6>
          <p>
            The peace is with you! <br />
            My sons: <b></b>
            Pray, pray, pray, to sustain peace. <br />
            Peace depends on your prayers. <br />
            Serious difficulties threaten the peace among you. <br />
            My Immaculate Heart suffers because suffering increases everyday.{" "}
            <br />
            Pray and fast for my intentions. <br />
            Live my messages! <br />
            I am the IMMACULATE MOTHER OF JESUS's EUCHARISTIC HEART! <br />
            I want to be listened to and worshipped. <br />
            ADORED IS GOD! ADORED IS GOD! <br />
            ADORED IS GOD! <br />I love you more every day. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 13 2002</h6>
          <p>
            My sons. Be generous with your brothers to be together with My
            Immaculate Heart. <br />
            Make small sacrifices and offer them to repair the insults and
            sacrileges which are said and made in front of the Sacred Sacrament.{" "}
            <br />
            I love you more every day. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 19 2002</h6>
          <p>
            Praise be to Jesus Christ! <br />
            Blessed you are in The Name of the Lord. Go on praying even in the
            middle of the tests, don't be afraid!, pray with the Sacred Rosary.
            The Sacred Rosary is the defense weapon which I am giving you and
            the remedy to all the wrongs. Don't separate yourselves from it.{" "}
            <br />
            Be Patient during the tests; The Light that will conquer all the
            darkness is shining. <br />
            Praise be to JESUS'S HOLY EUCHARISTIC HEART! <br />
            I love you more every day. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 30 2002</h6>
          <p>
            My children: <br />
            Open your hearts to Christ Savior's Love, today a "Saint" day. It is
            necessary, to discern the time when you are living, help others to
            discern this time of darkness, don't be cought. <br />
            Pray, pray, pray with more love and awareness to reach peace and to
            avoid conflicts. Open your hearts to God. Convert yourselves!
            totally, this is the only possible way to reach peace. Blessed you
            are. <br />
            I love you more every day. <br />
            Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 31 2002</h6>
          <p>
            Praise be to The Savior! <br />
            Come to the Lord , faithful souls. <br />
            Come, adore him. <br />
            Come, consecrate your souls to the Lord <br />
            Come adore him. <br />
            Indifferent cold souls, <br />
            Come, adore him. <br />
            God's Unknown souls, <br />
            come, adore God. <br />
            Come, every soul, <br />
            Come, adore God who is alive and has resuscitated <br />
            among you until the end. <br />
            Let us adore My Divine Son Jesus present in <br />
            The Sacred Sacrament! <br />
            Glorify God! <br />
            Aleluya, Aleluya, Hallelujah <br />
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>April 7 2002</h6>
          <p>
            Sons: <br />
            I speak to your hearts; I want to pour The Merciful Love of Jesus'
            Divine Heart over each soul . Experience the joy and the happiness
            of receiving this Love; as well as God gives it without measure!.
            Thank God for this immense Love. <br />
            Turn into instruments of this Love. <br />
            Pray to know deeply his Great Mercy. <br />
            Pray to be able to thank God. <br />
            Pray so that God's Mercy becomes life in you. <br />
            I love you more every day, and I bless you thoroughly. <br />
            Amen Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 1º 2002</h6>
          <p>
            Blessed you are my children, today which is so special. <br />
            Go on working and praying for my intentions; be patient when facing
            tribulations and be sober in everything you do. <br />
            Pray in family the Sacred Rosary; begin this prayer today joining it
            to My Immaculate Heart, to preserve to your families from all wrong.{" "}
            <br />
            Pray with patience and generosity for Argentina, your homeland,
            without despairing. Me, God's Mother protects you with my celestial
            mantel. <br />
            Pray, pray, pray persevere in your prayer! I am praying for you.{" "}
            <br />
            Blessed and Adored is Jesus's Holy Eucharistic Heart ! <br />
            I love you more every day. <br />
            Amen, Amen, Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>May 8 2002</h6>
          <p>
            Blessed you are my sons today which is so special for you! <br />
            Be blessed sowing true peace; first look for peace inside your
            hearts. <br />
            Look at Heaven, asking and begging for peace with serene
            perseverance. <br />
            Pray the Sacred Rosary for peace. First it is the prayer, God can do
            anything. Trust in your Celestial Father! <br />
            Blessed you are my sons with Christ's Peace! <br />
            I love you more every day. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 2 2002</h6>
          <p>
            Be patient and merciful with your brothers. I invite to love your
            your siblings a bit more every day to love your God who communicates
            his Love from his Holy Eucharistic Heart. <br />
            Surrender to this abyss of infinite charity. <br />
            Come closer to drink from his source of living water. <br />
            My sons: Jesus is waiting for you in the Sacred Communion, happy
            those who have been invited to this celestial banquet, and happy the
            soul who understands this infinite grace he is receiving. Don't
            receive the Holy Communion without a clean soul. <br />
            Adore Christ Savior! <br />
            Bless the Lord for his immense Love! <br />
            Glorify God Hallelujah!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 7 2002</h6>
          <p>
            Jesus says: <br />
            Come closer to Me. <br />
            Lock yourselves in Me. <br />
            Remain in Me. <br />
            Repair serious offenses, insults and irreverences made in My
            Presence. <br />
            The Sacred Sacramento. <br />
            Repair the insults and the sacrileges and essays against My Saint
            Names, <br />
            My Commandments, <br />
            My Holy Word, <br />
            My Holy Church, <br />
            My Sacred Mother. <br />
            "I am", I will be found by anyone who looks for me; I will attract
            him to My Heart, I will be your God and this will be my town. <br />
            Blessed you are. <br />
            Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>June 7 2002</h6>
          <p>
            Honor Jesus's Holy Eucharistic Heart" I am alive and present in The
            Sacred Sacrament. Don't be deceived by impure hearts. <br />
            My sons. I want to help you during this time of big sufferings and
            of dark tribulations, you are submerged in dirty seas, which move in
            any direction to contaminate you. Don't contaminate, clean
            yourselves if you are touched. <br />
            To those who are afflicted and heart-stricken I tell you to come
            closer to The Sacred Heart, with trust, without reservations. I am
            asking for your prayer for World Peace. Don't discard my requests
            for this intention. <br />
            This is when My Son is attentive to your requests, willing to listen
            to your supplications. This is the time of Jesus's Holy Eucharistic
            Heart and Mary's Immaculate Heart. This is the victory of Heaven,
            not of the earth. <br />
            My sons pray, pray with trust. Pray with trust. Pray for The Sacred
            Father my dear son. Blessed is everyone around the whole world.{" "}
            <br />
            Peace, Peace, Peace <br />
            Amen Amen Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>July 16 2002</h6>
          <p>
            Dear Children: <br />
            Blessed you are today! I want to give you happiness and hope; nor of
            material things which soon vanish, neither of false promises that
            never come true. I want to give you the hope that that this the road
            towards Love. <br />
            Love is my Divine Son Jesus. <br />
            Don't be afraid my sons, I am among you; don't stop, preach the
            God's Word. <br />
            How much sin there is! my sons. Convert yourselves soon to the Love!
            Blessed and adored is Jesus's Holy Eucharistic Heart! I love you
            more every day. <br />
            Amen, Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 5 2002</h6>
          <p>
            Praise be to the Lord , saint and Adored is The Lord! <br />
            Great happiness reigns today in Heaven, I want to share this
            happiness and this party with you . I attract you to my small Heart,
            inviting you to be small and humble, silent and deep people. Trust
            Me my sons! <br />
            Trust in my powerful intercession. I am your Mother and I guide you
            in the middle of the darkness, to take you to the light. <br />
            Pray with patience and perseverance., Be faithful to Jesus! <br />
            I love you more every day. <br />
            Blessed you are. Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>August 15 2002</h6>
          <p>
            My sons; come back to God!. Convert soon!. Change your life, pray
            with more fervor. Pray in family the Sacred Rosary. The world is
            going towards violence nowadays and the tendency increases. Violence
            darkens minds and empties hearts from God's Love. As a Mother I
            exhort you to live in peace, I call you urgently to pray for the
            peace. Pray and work for the peace, everybody; everybody should work
            for this intention, pray for the peace, pray to have peace in your
            souls, convey peace. I bless you with my maternal love. I love you
            more every day. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 13 2002</h6>
          <p>
            My sons: <br />
            Praise be to is God! <br />
            I invite to thank Heaven for the great grace of my presence among
            you. Take care of this grace! <br />
            The enemy wants to darken this gift; and he will use tricks of all
            type to disorient you. I invite you on this privileged day in the
            whole world to pray for "my Intentions" and for your fidelity.{" "}
            <br />
            Water with "constant prayer" and small sacrifices, this earth of
            beautiful fruits. I am happy among you! <br />
            Give up the wrong, take materialism away from your lives and be
            faithful day by day. "Blessed and Adored is Jesus's Holy Eucharistic
            Heart" I love you more every day. <br />
            Amen Hallelujah Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 15 2002</h6>
          <p>
            Jesus says: Move away from the darkness. Come closer to Me. "I am
            the Light of the World" those who are mine, are with me in My Light.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>September 25 2002</h6>
          <p>
            I am a safe shelter for those souls looking for conversion. I call
            you to join my Heart. <br />
            Those who don't believe, those who doubt. Those who explain
            everything, those without hope, those who have an ill bodies or
            souls, those who are sad and desperate, to this town which looks for
            me and adores me. <br />
            I look for lost children. <br />
            With tears I look for them. <br />
            With my Love I call them. <br />
            Until the end I will look for my sons to take them to My Divine Son
            "Road, Truth and Life." I love you a lot. <b></b>
            Amen, Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>October 12 2002</h6>
          <p>
            My sons: Praise be to Jesus Christ! <br />
            When this new dawn breaks I am praying with you. Pray for peace and
            harmony among you. I want to take you to a greater depth in the
            prayer. <br />
            Take the Sacred Rosary in your hands and begin to pray. <br />
            Meditate on this! <br />
            Pray in front of The Cross at home, don't have a cross just as an
            ornament; meditate in front of the cross, with tears and love.{" "}
            <br />
            Look at Jesus on The Cross. <br />
            Jesus is looking at you from the cross, he is listening to you, he
            understands you, he feels sorry for you, he loves you infinitely. If
            you pray in front of The Cross with love, you will receive what you
            are asking for. <br />
            How infinite Christ's Love is! <br />
            Look at Christ; look at him deeply from your heart. <br />
            Pray from your heart. <br />
            Adore Christ, adore him! <br />
            I love you and I bless you. <br />
            Amen, Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 1º 2002</h6>
          <p>
            Dear sons: <br />
            Come closer to My Divine Son Jesus, and remain in His Love, so that
            you can love your neighbour. Don't let anything or anybody interfere
            on your Road towards true Love. <br />
            Get rid of the chains that tie you to the wrong; purify and
            reconcile yourselves truly. Give yourselves away to Jesus totally.{" "}
            <br />
            Come closer to the Holy Communion, receive Life itself. <br />
            Glorify God! <br />
            Blessed you are, I love you more every day. <br />
            Amen, Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 7 2002</h6>
          <p>
            My sons: <br />
            Today you are blessed, you were blessed and you will be blessed by
            My Divine Son's infinite Love. I come to you as Mother Of Jesus's
            Holy Eucharistic Heart, so that you remain in this Divine Heart that
            loves you infinitely. <br />
            Don't reject this rain of graces which is falling from Heaven.{" "}
            <br />
            My small flock: <br />
            Convert soon! <br />
            Don't reject this call, open your hearts to the Grace. Be blessed!{" "}
            <br />
            Don't be afraid, I am by your side. I love you more every day. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>November 24 2002</h6>
          <p>
            My sons: during this time when you are living, there is desolation
            in your souls, distrust penetrates in your hearts, uncertainty is
            daily food; these facts darken your days, so it is difficult to
            distinguish between right and wrong. <br />
            But I tell you sons you Trust me! that I am your celestial Mother,
            messenger of the Love; surrender to me so that I drive you to The
            infinite Light of God's Love. <br />
            Every day I will be more near you, taking care of you and giving you
            my heat of Mother, no one who trusts me will be abandoned. Pray and
            trust. <br />
            I love you more every day. <br />
            Thank you for coming to meet me. <br />
            Amen Hallelujah Amen Hallelujah
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 8 2002</h6>
          <p>
            (Message given after the party that took place on December 7 2002, 7
            in honour to the Immaculate Mother of Jesus's Holy Eucharistic
            Heart) Adored is Jesus's Holy Eucharistic Heart! Thank you my sons!{" "}
            <br />
            Today my Heart overflows with immense happiness because you trust in
            my intercession. "I am yours." <br />
            I am your compassionate Mother. <br />
            The Ángel and Saints from Heaven sang hymns of commendations to the
            Lord due to this party which comes from Heart, fruit of the prayer.{" "}
            <br />
            With your loving cult, you mitigate the pain of My Immaculate Heart.{" "}
            <br />
            My sons God wants you to do a holy a perfect heart, from your
            hearts! I want you to spread this good news to the world four
            cardinal points. Go on coming to me, I am waiting for you children
            of the world, in this sacred place. I love you more every day, I
            bless you thoroughly. <br />
            Amen, Hallelujah, Hallelujah, Hallelujah.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 2002</h6>
          <p>
            I can see the Holy Virgin, radiant of beauty and happiness, she
            greets me saying: <br />
            María daughter today I will give you a secret of my Heart. <br />
            Then I see in a vision The Sacred Virgin in the birth cave, She is
            high above the earth in ecstasy, with an incredible beauty,
            surrounded by an immense light. <br />
            I see her prominent stomach shining with golden light, and this very
            same light illumninates the place where María's Immaculate Heart is.{" "}
            <br />
            The Mother tells me: María daughter, when the time of the birth was
            completed I understood inside my woman heart that My Divine Son was
            going to be separated from my pure breast, a sacred instant!. All my
            being was covered with divine caresses, and with perfect knowledge,
            I completely understood this sacred mission of being Mother and Gods
            Mother. <br />
            Then the light of the Infinite Love covered me totally. <br />
            When the Divine Boy was put in my arms beside my pure breast I felt
            his Love and I loved him as Mother. My pure breast didn't experience
            the emptyness; it has always been full of God's Love, totally
            covered by God's will . <br />
            Glorify God! <br />
            Blessed you always are daughter of my Heart. <br />
            Happy Birthday!
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>December 25 2002</h6>
          <p>
            Praise be to God! <br />
            Dear sons Pray for the Peace! at this Christmas, pray with
            perseverance asking for peace, especially soul peace; pray to be
            good people. <br />
            Be blessed and fair. Pray truly and in Spirit, in order to be worthy
            of this true peace. Be blessed in the Lord's peace. <br />
            I love you more every day. <br />
            Hallelujah, Hallelujah, Hallelujah <br />
            Amen, Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>January 12 2003</h6>
          <p>
            Wake up! to faith my sons. <br />
            Come closer to the divine light of faith. <br />
            Faith is my Divine Son's light. <br />
            ¡ Blessed are those who remain faithful!. <br />
            Blessed you are are!. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>February 2 2003</h6>
          <p>
            Blessed you are! my sons, today which is so special. <br />
            Today, I wish I could give your hearts to God so that you are light
            among darkness. Mature wheat, instead of weed. <br />
            Love in the middle of hate. <br />
            Pray, for the peace of the nations. <br />
            Don't move away from the Sacred Rosary "source of light"; pray the
            Sacred Rosary with strengh; with spirit, so that this light
            illuminates more every day. <br />
            When this new dawn breaks, I offer you to the Lord , don't stop!. Go
            ahead. I love you more every day. God should be adored for
            centuries!. Amen.
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 19 2003</h6>
          <p>
            Today The Mother was beautiful, and her face, which looked down was
            full of Love and Peace. Her face looked humidified or perspired.{" "}
            <br />
            The Virgin has in her face the eternal beauty of Love. <br />
            Saint Joseph remains in silence, near her, it seems he is praying.
            In a moment of silence The Virgin and Saint Joseph remain praying.
            They let me contemplate them in prayer, they are joined in prayer.
            How beautiful Saint Joseph is! <br />
            Saint Joseph blesses with the Virgin. <br />
            (Appearance of the Immaculate Mother of Jesus's Holy Eucharistic
            Heart and Saint Joseph in Salta, Argentina.)
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>March 25 2003</h6>
          <p>
            I am your Mother, and I love you in such a way that you won't be
            able to understand while you are in this world. <br />
            Today, I wish you would enjoy next to my heart this "unbeatable
            Love." <b></b>
            Meditate on this my sons. Trust in my Immaculate Heart. <b></b>
            Blessed you are my sons! <br />
            Amen, Amen, Amen
          </p>
        </div>

        <div className="col-12 mt-5">
          <h6>Salta, April 1º 2003</h6>
          <p>
            Jesus says: <br />
            Adore me, during day and night! <br />
            Come to Me and adore me unceasingly, to get "peace." <b></b>
            Amen.
          </p>
        </div>
      </LayoutMensajesVirgen>
    </>
  );
}
